import type { LatLon } from "@radar-sim/schema";

/**
 * Coastline polylines derived from OpenStreetMap data via Overpass API,
 * clipped to the plockton bounding box and Douglas–Peucker simplified
 * at ~33 m tolerance. Re-fetch with /tmp/fetch-coastline.mjs.
 *
 * Convention:
 *   - PLOCKTON_MAINLAND is an OPEN polyline along the mainland's seaward edge,
 *     clipped at the bounding-box left/right margins. Renderers close it
 *     by extending to the chart's top edge.
 *   - PLOCKTON_ISLANDS are CLOSED polygons (first === last point). Includes
 *     islands and any inland water features that would draw as land.
 *
 * © OpenStreetMap contributors, ODbL.
 */

export const PLOCKTON_MAINLAND: ReadonlyArray<LatLon> = [
  { lat: 57.54983, lon: -5.85369 },
  { lat: 57.54991, lon: -5.85443 },
  { lat: 57.54858, lon: -5.8541 },
  { lat: 57.54818, lon: -5.85457 },
  { lat: 57.54779, lon: -5.85418 },
  { lat: 57.54595, lon: -5.85416 },
  { lat: 57.54475, lon: -5.85331 },
  { lat: 57.54389, lon: -5.85401 },
  { lat: 57.54298, lon: -5.85325 },
  { lat: 57.54245, lon: -5.85386 },
  { lat: 57.54005, lon: -5.85429 },
  { lat: 57.53818, lon: -5.85384 },
  { lat: 57.5371, lon: -5.85512 },
  { lat: 57.53679, lon: -5.85457 },
  { lat: 57.53669, lon: -5.85506 },
  { lat: 57.5362, lon: -5.85459 },
  { lat: 57.53606, lon: -5.85499 },
  { lat: 57.53563, lon: -5.85485 },
  { lat: 57.5354, lon: -5.85591 },
  { lat: 57.53479, lon: -5.85527 },
  { lat: 57.53471, lon: -5.85567 },
  { lat: 57.5342, lon: -5.85522 },
  { lat: 57.53363, lon: -5.8555 },
  { lat: 57.53144, lon: -5.85493 },
  { lat: 57.53139, lon: -5.85457 },
  { lat: 57.53017, lon: -5.85493 },
  { lat: 57.52974, lon: -5.8544 },
  { lat: 57.52789, lon: -5.85406 },
  { lat: 57.52736, lon: -5.8546 },
  { lat: 57.52714, lon: -5.85408 },
  { lat: 57.52671, lon: -5.85421 },
  { lat: 57.52439, lon: -5.85629 },
  { lat: 57.52322, lon: -5.85663 },
  { lat: 57.52019, lon: -5.85967 },
  { lat: 57.51928, lon: -5.85967 },
  { lat: 57.51878, lon: -5.8605 },
  { lat: 57.51796, lon: -5.86054 },
  { lat: 57.51662, lon: -5.86187 },
  { lat: 57.5152, lon: -5.86245 },
  { lat: 57.51365, lon: -5.86238 },
  { lat: 57.51339, lon: -5.8628 },
  { lat: 57.51327, lon: -5.86231 },
  { lat: 57.51148, lon: -5.86351 },
  { lat: 57.51141, lon: -5.86398 },
  { lat: 57.50877, lon: -5.86473 },
  { lat: 57.5081, lon: -5.86584 },
  { lat: 57.50819, lon: -5.86718 },
  { lat: 57.50757, lon: -5.86752 },
  { lat: 57.50748, lon: -5.86693 },
  { lat: 57.50506, lon: -5.86822 },
  { lat: 57.50389, lon: -5.86974 },
  { lat: 57.50376, lon: -5.86935 },
  { lat: 57.50323, lon: -5.87051 },
  { lat: 57.50171, lon: -5.87005 },
  { lat: 57.5014, lon: -5.86907 },
  { lat: 57.49887, lon: -5.86775 },
  { lat: 57.49783, lon: -5.86814 },
  { lat: 57.49703, lon: -5.86772 },
  { lat: 57.49645, lon: -5.86816 },
  { lat: 57.49273, lon: -5.86778 },
  { lat: 57.49006, lon: -5.87123 },
  { lat: 57.4885, lon: -5.87103 },
  { lat: 57.48848, lon: -5.87058 },
  { lat: 57.48584, lon: -5.86899 },
  { lat: 57.4855, lon: -5.86951 },
  { lat: 57.48368, lon: -5.86976 },
  { lat: 57.48279, lon: -5.86949 },
  { lat: 57.48207, lon: -5.86857 },
  { lat: 57.48139, lon: -5.86891 },
  { lat: 57.48114, lon: -5.8685 },
  { lat: 57.48011, lon: -5.8697 },
  { lat: 57.47899, lon: -5.86926 },
  { lat: 57.47802, lon: -5.8716 },
  { lat: 57.47732, lon: -5.87117 },
  { lat: 57.47706, lon: -5.87169 },
  { lat: 57.47622, lon: -5.87156 },
  { lat: 57.47563, lon: -5.87298 },
  { lat: 57.47275, lon: -5.87259 },
  { lat: 57.47026, lon: -5.87104 },
  { lat: 57.46974, lon: -5.86989 },
  { lat: 57.46946, lon: -5.86761 },
  { lat: 57.47023, lon: -5.86576 },
  { lat: 57.47066, lon: -5.86592 },
  { lat: 57.47128, lon: -5.86482 },
  { lat: 57.47044, lon: -5.86373 },
  { lat: 57.46956, lon: -5.86393 },
  { lat: 57.46779, lon: -5.866 },
  { lat: 57.46694, lon: -5.86592 },
  { lat: 57.46136, lon: -5.86189 },
  { lat: 57.45965, lon: -5.86164 },
  { lat: 57.45473, lon: -5.86221 },
  { lat: 57.45248, lon: -5.86128 },
  { lat: 57.44968, lon: -5.86084 },
  { lat: 57.44363, lon: -5.85574 },
  { lat: 57.44242, lon: -5.85405 },
  { lat: 57.44207, lon: -5.85221 },
  { lat: 57.44134, lon: -5.85114 },
  { lat: 57.44155, lon: -5.84753 },
  { lat: 57.44068, lon: -5.84263 },
  { lat: 57.4419, lon: -5.82511 },
  { lat: 57.44349, lon: -5.82014 },
  { lat: 57.44367, lon: -5.81721 },
  { lat: 57.44126, lon: -5.81169 },
  { lat: 57.4422, lon: -5.80973 },
  { lat: 57.44108, lon: -5.80996 },
  { lat: 57.44014, lon: -5.80756 },
  { lat: 57.43897, lon: -5.80648 },
  { lat: 57.43776, lon: -5.80596 },
  { lat: 57.43681, lon: -5.80736 },
  { lat: 57.43409, lon: -5.81245 },
  { lat: 57.43367, lon: -5.81586 },
  { lat: 57.42889, lon: -5.81878 },
  { lat: 57.42721, lon: -5.82182 },
  { lat: 57.42572, lon: -5.82205 },
  { lat: 57.42279, lon: -5.82352 },
  { lat: 57.42136, lon: -5.82361 },
  { lat: 57.41926, lon: -5.82542 },
  { lat: 57.41649, lon: -5.82495 },
  { lat: 57.41404, lon: -5.82545 },
  { lat: 57.41142, lon: -5.82477 },
  { lat: 57.41083, lon: -5.8234 },
  { lat: 57.41176, lon: -5.8216 },
  { lat: 57.41239, lon: -5.82178 },
  { lat: 57.41235, lon: -5.82016 },
  { lat: 57.41008, lon: -5.81719 },
  { lat: 57.40845, lon: -5.81697 },
  { lat: 57.40816, lon: -5.81635 },
  { lat: 57.40675, lon: -5.81559 },
  { lat: 57.40607, lon: -5.81374 },
  { lat: 57.40621, lon: -5.81311 },
  { lat: 57.40693, lon: -5.81318 },
  { lat: 57.40703, lon: -5.81261 },
  { lat: 57.40599, lon: -5.81086 },
  { lat: 57.40197, lon: -5.81013 },
  { lat: 57.39904, lon: -5.80731 },
  { lat: 57.39824, lon: -5.80831 },
  { lat: 57.39871, lon: -5.80887 },
  { lat: 57.39834, lon: -5.80974 },
  { lat: 57.39906, lon: -5.81003 },
  { lat: 57.39915, lon: -5.81063 },
  { lat: 57.39804, lon: -5.81169 },
  { lat: 57.39413, lon: -5.80911 },
  { lat: 57.39395, lon: -5.80763 },
  { lat: 57.39325, lon: -5.80672 },
  { lat: 57.39226, lon: -5.80682 },
  { lat: 57.39137, lon: -5.8061 },
  { lat: 57.39356, lon: -5.80974 },
  { lat: 57.39334, lon: -5.81038 },
  { lat: 57.39503, lon: -5.81123 },
  { lat: 57.39505, lon: -5.81196 },
  { lat: 57.39405, lon: -5.81277 },
  { lat: 57.39616, lon: -5.8131 },
  { lat: 57.3964, lon: -5.81498 },
  { lat: 57.3972, lon: -5.81487 },
  { lat: 57.39756, lon: -5.81351 },
  { lat: 57.39858, lon: -5.81416 },
  { lat: 57.3988, lon: -5.81546 },
  { lat: 57.39996, lon: -5.81595 },
  { lat: 57.39993, lon: -5.81718 },
  { lat: 57.40055, lon: -5.8178 },
  { lat: 57.40014, lon: -5.81884 },
  { lat: 57.40137, lon: -5.81886 },
  { lat: 57.4016, lon: -5.82059 },
  { lat: 57.40139, lon: -5.8209 },
  { lat: 57.39979, lon: -5.82006 },
  { lat: 57.39491, lon: -5.82236 },
  { lat: 57.39315, lon: -5.8223 },
  { lat: 57.39079, lon: -5.82001 },
  { lat: 57.38972, lon: -5.82105 },
  { lat: 57.38851, lon: -5.81917 },
  { lat: 57.38856, lon: -5.8215 },
  { lat: 57.38618, lon: -5.82243 },
  { lat: 57.38565, lon: -5.82323 },
  { lat: 57.38684, lon: -5.82349 },
  { lat: 57.38811, lon: -5.82536 },
  { lat: 57.38935, lon: -5.82552 },
  { lat: 57.39047, lon: -5.82477 },
  { lat: 57.39165, lon: -5.83006 },
  { lat: 57.39215, lon: -5.83043 },
  { lat: 57.3901, lon: -5.83144 },
  { lat: 57.38906, lon: -5.83048 },
  { lat: 57.38853, lon: -5.8286 },
  { lat: 57.38763, lon: -5.8286 },
  { lat: 57.38665, lon: -5.82767 },
  { lat: 57.38507, lon: -5.82734 },
  { lat: 57.38473, lon: -5.82669 },
  { lat: 57.38222, lon: -5.8265 },
  { lat: 57.38103, lon: -5.82879 },
  { lat: 57.37977, lon: -5.82916 },
  { lat: 57.3795, lon: -5.82789 },
  { lat: 57.37818, lon: -5.82807 },
  { lat: 57.37769, lon: -5.82699 },
  { lat: 57.37709, lon: -5.8268 },
  { lat: 57.37716, lon: -5.82566 },
  { lat: 57.37617, lon: -5.8255 },
  { lat: 57.37425, lon: -5.82374 },
  { lat: 57.37324, lon: -5.82585 },
  { lat: 57.37037, lon: -5.82377 },
  { lat: 57.3679, lon: -5.82391 },
  { lat: 57.36511, lon: -5.82195 },
  { lat: 57.36495, lon: -5.8213 },
  { lat: 57.36363, lon: -5.82234 },
  { lat: 57.36325, lon: -5.8213 },
  { lat: 57.36247, lon: -5.82158 },
  { lat: 57.36144, lon: -5.82044 },
  { lat: 57.36064, lon: -5.82144 },
  { lat: 57.36058, lon: -5.82072 },
  { lat: 57.36126, lon: -5.82026 },
  { lat: 57.36133, lon: -5.81959 },
  { lat: 57.36053, lon: -5.81752 },
  { lat: 57.3623, lon: -5.81306 },
  { lat: 57.36374, lon: -5.81289 },
  { lat: 57.36396, lon: -5.81246 },
  { lat: 57.36479, lon: -5.81299 },
  { lat: 57.3656, lon: -5.81263 },
  { lat: 57.36671, lon: -5.81387 },
  { lat: 57.36841, lon: -5.81409 },
  { lat: 57.37012, lon: -5.81602 },
  { lat: 57.37048, lon: -5.8133 },
  { lat: 57.37267, lon: -5.81256 },
  { lat: 57.3721, lon: -5.81128 },
  { lat: 57.3725, lon: -5.81037 },
  { lat: 57.37396, lon: -5.8106 },
  { lat: 57.3759, lon: -5.80914 },
  { lat: 57.37569, lon: -5.80819 },
  { lat: 57.37619, lon: -5.80843 },
  { lat: 57.37734, lon: -5.80763 },
  { lat: 57.37597, lon: -5.80721 },
  { lat: 57.37524, lon: -5.80627 },
  { lat: 57.37159, lon: -5.80822 },
  { lat: 57.37071, lon: -5.80634 },
  { lat: 57.36905, lon: -5.80748 },
  { lat: 57.36872, lon: -5.80689 },
  { lat: 57.36813, lon: -5.8076 },
  { lat: 57.36828, lon: -5.80689 },
  { lat: 57.36758, lon: -5.80696 },
  { lat: 57.36734, lon: -5.80632 },
  { lat: 57.36644, lon: -5.80686 },
  { lat: 57.36623, lon: -5.80639 },
  { lat: 57.36594, lon: -5.80731 },
  { lat: 57.36528, lon: -5.80684 },
  { lat: 57.36489, lon: -5.80729 },
  { lat: 57.36372, lon: -5.80524 },
  { lat: 57.36291, lon: -5.80549 },
  { lat: 57.36288, lon: -5.80489 },
  { lat: 57.36167, lon: -5.80552 },
  { lat: 57.36116, lon: -5.80536 },
  { lat: 57.36105, lon: -5.80461 },
  { lat: 57.35949, lon: -5.80496 },
  { lat: 57.35848, lon: -5.80459 },
  { lat: 57.35791, lon: -5.80292 },
  { lat: 57.35734, lon: -5.8025 },
  { lat: 57.35786, lon: -5.80032 },
  { lat: 57.35706, lon: -5.79921 },
  { lat: 57.35547, lon: -5.79946 },
  { lat: 57.35536, lon: -5.79991 },
  { lat: 57.35445, lon: -5.79856 },
  { lat: 57.35378, lon: -5.79836 },
  { lat: 57.35358, lon: -5.79657 },
  { lat: 57.35291, lon: -5.79709 },
  { lat: 57.35332, lon: -5.79635 },
  { lat: 57.35305, lon: -5.79566 },
  { lat: 57.35171, lon: -5.79612 },
  { lat: 57.35116, lon: -5.79548 },
  { lat: 57.35107, lon: -5.79404 },
  { lat: 57.35066, lon: -5.79422 },
  { lat: 57.35005, lon: -5.79322 },
  { lat: 57.35071, lon: -5.79142 },
  { lat: 57.35032, lon: -5.78986 },
  { lat: 57.34937, lon: -5.79036 },
  { lat: 57.34921, lon: -5.7898 },
  { lat: 57.34899, lon: -5.79005 },
  { lat: 57.34851, lon: -5.78788 },
  { lat: 57.34778, lon: -5.78872 },
  { lat: 57.34791, lon: -5.79025 },
  { lat: 57.34789, lon: -5.78919 },
  { lat: 57.34763, lon: -5.78977 },
  { lat: 57.34715, lon: -5.78975 },
  { lat: 57.34755, lon: -5.7886 },
  { lat: 57.34723, lon: -5.78881 },
  { lat: 57.3469, lon: -5.78822 },
  { lat: 57.34639, lon: -5.7887 },
  { lat: 57.34634, lon: -5.7861 },
  { lat: 57.34683, lon: -5.78546 },
  { lat: 57.34676, lon: -5.78437 },
  { lat: 57.34635, lon: -5.78492 },
  { lat: 57.34676, lon: -5.78359 },
  { lat: 57.34631, lon: -5.78247 },
  { lat: 57.3469, lon: -5.78044 },
  { lat: 57.34731, lon: -5.77508 },
  { lat: 57.34872, lon: -5.77255 },
  { lat: 57.34878, lon: -5.76971 },
  { lat: 57.34829, lon: -5.7679 },
  { lat: 57.34971, lon: -5.7622 },
  { lat: 57.34947, lon: -5.75922 },
  { lat: 57.35024, lon: -5.75375 },
  { lat: 57.34997, lon: -5.75232 },
  { lat: 57.35075, lon: -5.74976 },
  { lat: 57.35054, lon: -5.74821 },
  { lat: 57.35229, lon: -5.74112 },
  { lat: 57.35391, lon: -5.73745 },
  { lat: 57.35403, lon: -5.7355 },
  { lat: 57.35374, lon: -5.7359 },
  { lat: 57.35452, lon: -5.73366 },
  { lat: 57.35424, lon: -5.7323 },
  { lat: 57.35495, lon: -5.72938 },
  { lat: 57.3567, lon: -5.72605 },
  { lat: 57.35644, lon: -5.72558 },
  { lat: 57.35741, lon: -5.72457 },
  { lat: 57.35837, lon: -5.72156 },
  { lat: 57.35946, lon: -5.72155 },
  { lat: 57.35975, lon: -5.72227 },
  { lat: 57.36044, lon: -5.72173 },
  { lat: 57.36271, lon: -5.71711 },
  { lat: 57.36309, lon: -5.71677 },
  { lat: 57.36349, lon: -5.71717 },
  { lat: 57.36377, lon: -5.71643 },
  { lat: 57.36415, lon: -5.71659 },
  { lat: 57.3654, lon: -5.71334 },
  { lat: 57.36619, lon: -5.70823 },
  { lat: 57.36649, lon: -5.70802 },
  { lat: 57.36677, lon: -5.70856 },
  { lat: 57.36705, lon: -5.70715 },
  { lat: 57.36754, lon: -5.70723 },
  { lat: 57.36843, lon: -5.70576 },
  { lat: 57.37053, lon: -5.6994 },
  { lat: 57.37278, lon: -5.69684 },
  { lat: 57.37438, lon: -5.69323 },
  { lat: 57.37661, lon: -5.69207 },
  { lat: 57.37768, lon: -5.68927 },
  { lat: 57.37832, lon: -5.68876 },
  { lat: 57.37835, lon: -5.68151 },
  { lat: 57.37864, lon: -5.68112 },
  { lat: 57.37868, lon: -5.68159 },
  { lat: 57.37909, lon: -5.68145 },
  { lat: 57.37883, lon: -5.68043 },
  { lat: 57.37916, lon: -5.68132 },
  { lat: 57.37981, lon: -5.68131 },
  { lat: 57.38024, lon: -5.68045 },
  { lat: 57.3807, lon: -5.67574 },
  { lat: 57.38211, lon: -5.67175 },
  { lat: 57.38194, lon: -5.67002 },
  { lat: 57.38243, lon: -5.6695 },
  { lat: 57.38241, lon: -5.66829 },
  { lat: 57.38327, lon: -5.66728 },
  { lat: 57.38382, lon: -5.66731 },
  { lat: 57.38513, lon: -5.66491 },
  { lat: 57.38619, lon: -5.66424 },
  { lat: 57.38636, lon: -5.66291 },
  { lat: 57.38725, lon: -5.66204 },
  { lat: 57.38851, lon: -5.65899 },
  { lat: 57.38889, lon: -5.65423 },
  { lat: 57.38998, lon: -5.65084 },
  { lat: 57.38959, lon: -5.64919 },
  { lat: 57.38987, lon: -5.64638 },
  { lat: 57.39117, lon: -5.64154 },
  { lat: 57.39214, lon: -5.63953 },
  { lat: 57.39242, lon: -5.64012 },
  { lat: 57.39403, lon: -5.63751 },
  { lat: 57.39377, lon: -5.6367 },
  { lat: 57.39424, lon: -5.63576 },
  { lat: 57.3953, lon: -5.63637 },
  { lat: 57.39749, lon: -5.63304 },
  { lat: 57.39807, lon: -5.62902 },
  { lat: 57.39765, lon: -5.62686 },
  { lat: 57.39792, lon: -5.62489 },
  { lat: 57.39861, lon: -5.62466 },
  { lat: 57.40003, lon: -5.62531 },
  { lat: 57.40054, lon: -5.62469 },
  { lat: 57.4013, lon: -5.62583 },
  { lat: 57.40335, lon: -5.62384 },
  { lat: 57.40496, lon: -5.62423 },
  { lat: 57.40798, lon: -5.61732 },
  { lat: 57.41093, lon: -5.61508 },
  { lat: 57.41486, lon: -5.61345 },
  { lat: 57.41655, lon: -5.61152 },
  { lat: 57.41679, lon: -5.61017 },
  { lat: 57.41819, lon: -5.61005 },
  { lat: 57.41879, lon: -5.6087 },
  { lat: 57.41928, lon: -5.60864 },
  { lat: 57.41905, lon: -5.60713 },
  { lat: 57.41871, lon: -5.6071 },
  { lat: 57.41772, lon: -5.60763 },
  { lat: 57.41811, lon: -5.60823 },
  { lat: 57.4176, lon: -5.60813 },
  { lat: 57.41712, lon: -5.60911 },
  { lat: 57.41562, lon: -5.60872 },
  { lat: 57.41527, lon: -5.60902 },
  { lat: 57.41496, lon: -5.6079 },
  { lat: 57.41352, lon: -5.60744 },
  { lat: 57.41259, lon: -5.60639 },
  { lat: 57.41194, lon: -5.60641 },
  { lat: 57.4079, lon: -5.60973 },
  { lat: 57.4049, lon: -5.61376 },
  { lat: 57.40124, lon: -5.61352 },
  { lat: 57.40049, lon: -5.61478 },
  { lat: 57.39969, lon: -5.61496 },
  { lat: 57.40006, lon: -5.61213 },
  { lat: 57.3985, lon: -5.60675 },
  { lat: 57.39783, lon: -5.60615 },
  { lat: 57.39754, lon: -5.60711 },
  { lat: 57.39688, lon: -5.60706 },
  { lat: 57.3972, lon: -5.60513 },
  { lat: 57.39671, lon: -5.60563 },
  { lat: 57.3972, lon: -5.60509 },
  { lat: 57.39618, lon: -5.6037 },
  { lat: 57.39521, lon: -5.60361 },
  { lat: 57.39572, lon: -5.6005 },
  { lat: 57.39552, lon: -5.59836 },
  { lat: 57.39338, lon: -5.59626 },
  { lat: 57.3911, lon: -5.59621 },
  { lat: 57.39052, lon: -5.59453 },
  { lat: 57.38871, lon: -5.5966 },
  { lat: 57.38801, lon: -5.59683 },
  { lat: 57.38761, lon: -5.59889 },
  { lat: 57.38777, lon: -5.60233 },
  { lat: 57.38549, lon: -5.60651 },
  { lat: 57.38543, lon: -5.60756 },
  { lat: 57.38582, lon: -5.60781 },
  { lat: 57.38546, lon: -5.61001 },
  { lat: 57.38472, lon: -5.60853 },
  { lat: 57.38388, lon: -5.60885 },
  { lat: 57.38356, lon: -5.60977 },
  { lat: 57.38404, lon: -5.61187 },
  { lat: 57.38345, lon: -5.61399 },
  { lat: 57.38328, lon: -5.619 },
  { lat: 57.38285, lon: -5.62052 },
  { lat: 57.3811, lon: -5.62264 },
  { lat: 57.3805, lon: -5.62452 },
  { lat: 57.38022, lon: -5.62674 },
  { lat: 57.38074, lon: -5.63056 },
  { lat: 57.38017, lon: -5.6338 },
  { lat: 57.37787, lon: -5.63708 },
  { lat: 57.37646, lon: -5.63801 },
  { lat: 57.37596, lon: -5.63944 },
  { lat: 57.37536, lon: -5.63976 },
  { lat: 57.37325, lon: -5.63881 },
  { lat: 57.37289, lon: -5.63955 },
  { lat: 57.37142, lon: -5.63668 },
  { lat: 57.37041, lon: -5.63585 },
  { lat: 57.36971, lon: -5.63594 },
  { lat: 57.36801, lon: -5.63493 },
  { lat: 57.36714, lon: -5.63578 },
  { lat: 57.36639, lon: -5.63577 },
  { lat: 57.36649, lon: -5.63402 },
  { lat: 57.36555, lon: -5.63362 },
  { lat: 57.36545, lon: -5.63288 },
  { lat: 57.36494, lon: -5.63269 },
  { lat: 57.36699, lon: -5.62669 },
  { lat: 57.36674, lon: -5.62593 },
  { lat: 57.36623, lon: -5.62615 },
  { lat: 57.36606, lon: -5.62457 },
  { lat: 57.36524, lon: -5.62342 },
  { lat: 57.36522, lon: -5.62019 },
  { lat: 57.36568, lon: -5.6187 },
  { lat: 57.36479, lon: -5.61626 },
  { lat: 57.36536, lon: -5.61238 },
  { lat: 57.36477, lon: -5.61009 },
  { lat: 57.36536, lon: -5.60217 },
  { lat: 57.36515, lon: -5.59923 },
  { lat: 57.36407, lon: -5.59855 },
  { lat: 57.3624, lon: -5.60161 },
  { lat: 57.36163, lon: -5.60398 },
  { lat: 57.3625, lon: -5.60675 },
  { lat: 57.36241, lon: -5.60849 },
  { lat: 57.36202, lon: -5.60989 },
  { lat: 57.35978, lon: -5.61153 },
  { lat: 57.35914, lon: -5.61328 },
  { lat: 57.3587, lon: -5.61121 },
  { lat: 57.35747, lon: -5.60951 },
  { lat: 57.35755, lon: -5.60854 },
  { lat: 57.35582, lon: -5.60667 },
  { lat: 57.35579, lon: -5.60384 },
  { lat: 57.35515, lon: -5.60178 },
  { lat: 57.35642, lon: -5.5975 },
  { lat: 57.35658, lon: -5.59374 },
  { lat: 57.35789, lon: -5.58962 },
  { lat: 57.35951, lon: -5.58122 },
  { lat: 57.35909, lon: -5.57624 },
  { lat: 57.35799, lon: -5.57436 },
  { lat: 57.35857, lon: -5.57198 },
  { lat: 57.35818, lon: -5.56902 },
  { lat: 57.35862, lon: -5.56835 },
  { lat: 57.35781, lon: -5.56628 },
  { lat: 57.35986, lon: -5.55666 },
  { lat: 57.35937, lon: -5.55585 },
  { lat: 57.35887, lon: -5.55627 },
  { lat: 57.35854, lon: -5.55529 },
  { lat: 57.35803, lon: -5.55789 },
  { lat: 57.35752, lon: -5.55738 },
  { lat: 57.35857, lon: -5.55381 },
  { lat: 57.35832, lon: -5.55151 },
  { lat: 57.35929, lon: -5.55083 },
  { lat: 57.36149, lon: -5.55196 },
  { lat: 57.36308, lon: -5.54728 },
  { lat: 57.3632, lon: -5.54535 },
  { lat: 57.36404, lon: -5.54577 },
  { lat: 57.36434, lon: -5.54345 },
  { lat: 57.36484, lon: -5.54345 },
  { lat: 57.36556, lon: -5.54112 },
  { lat: 57.36649, lon: -5.54065 },
  { lat: 57.37004, lon: -5.53429 },
  { lat: 57.37129, lon: -5.53354 },
  { lat: 57.37273, lon: -5.53119 },
  { lat: 57.37351, lon: -5.53071 },
  { lat: 57.37484, lon: -5.52868 },
  { lat: 57.37576, lon: -5.52608 },
  { lat: 57.37644, lon: -5.52635 },
  { lat: 57.3777, lon: -5.52518 },
  { lat: 57.37805, lon: -5.52211 },
  { lat: 57.37874, lon: -5.52164 },
  { lat: 57.37937, lon: -5.51946 },
  { lat: 57.37974, lon: -5.51903 },
  { lat: 57.38213, lon: -5.51939 },
  { lat: 57.38211, lon: -5.51832 },
  { lat: 57.38323, lon: -5.51798 },
  { lat: 57.38456, lon: -5.51383 },
  { lat: 57.38484, lon: -5.51396 },
  { lat: 57.38576, lon: -5.50982 },
  { lat: 57.3862, lon: -5.50985 },
  { lat: 57.38723, lon: -5.50833 },
  { lat: 57.38742, lon: -5.50643 },
  { lat: 57.38798, lon: -5.50603 },
  { lat: 57.38744, lon: -5.50291 },
  { lat: 57.38807, lon: -5.49863 },
  { lat: 57.3885, lon: -5.49989 },
  { lat: 57.38922, lon: -5.49851 },
  { lat: 57.38916, lon: -5.503 },
  { lat: 57.38857, lon: -5.50561 },
  { lat: 57.38899, lon: -5.50779 },
  { lat: 57.38962, lon: -5.50839 },
  { lat: 57.39036, lon: -5.50822 },
  { lat: 57.39073, lon: -5.50758 },
  { lat: 57.392, lon: -5.50711 },
  { lat: 57.39234, lon: -5.50605 },
  { lat: 57.39285, lon: -5.50627 },
  { lat: 57.39368, lon: -5.50558 },
  { lat: 57.39557, lon: -5.50205 },
  { lat: 57.39522, lon: -5.5022 },
  { lat: 57.39502, lon: -5.50139 },
  { lat: 57.39535, lon: -5.49977 },
  { lat: 57.39624, lon: -5.50021 },
  { lat: 57.39538, lon: -5.49922 },
  { lat: 57.3978, lon: -5.49653 },
  { lat: 57.39815, lon: -5.49677 },
  { lat: 57.39742, lon: -5.49725 },
  { lat: 57.3978, lon: -5.49755 },
  { lat: 57.39818, lon: -5.49725 },
  { lat: 57.39891, lon: -5.49569 },
  { lat: 57.39968, lon: -5.49185 },
  { lat: 57.4035, lon: -5.4797 },
  { lat: 57.40541, lon: -5.47866 },
  { lat: 57.4064, lon: -5.47738 },
  { lat: 57.40986, lon: -5.47496 },
  { lat: 57.41209, lon: -5.47504 },
  { lat: 57.4132, lon: -5.47248 },
  { lat: 57.4144, lon: -5.47221 },
  { lat: 57.41434, lon: -5.47167 },
  { lat: 57.41637, lon: -5.46971 },
  { lat: 57.41641, lon: -5.46808 },
  { lat: 57.41769, lon: -5.46623 },
  { lat: 57.41837, lon: -5.46592 },
  { lat: 57.41856, lon: -5.46646 },
  { lat: 57.41857, lon: -5.46471 },
  { lat: 57.42129, lon: -5.45975 },
  { lat: 57.42136, lon: -5.45906 },
  { lat: 57.42095, lon: -5.45886 },
  { lat: 57.42128, lon: -5.4582 },
  { lat: 57.42198, lon: -5.45779 },
  { lat: 57.42166, lon: -5.45654 },
  { lat: 57.42242, lon: -5.45555 },
  { lat: 57.4216, lon: -5.4563 },
  { lat: 57.42156, lon: -5.45508 },
  { lat: 57.42267, lon: -5.45433 },
  { lat: 57.42285, lon: -5.4547 },
  { lat: 57.42307, lon: -5.45286 },
  { lat: 57.42241, lon: -5.45457 },
  { lat: 57.42208, lon: -5.45419 },
  { lat: 57.42321, lon: -5.4515 },
  { lat: 57.42257, lon: -5.45211 },
  { lat: 57.42258, lon: -5.45145 },
  { lat: 57.42306, lon: -5.45071 },
  { lat: 57.42427, lon: -5.45026 },
  { lat: 57.42455, lon: -5.44933 },
  { lat: 57.42396, lon: -5.4494 },
  { lat: 57.42471, lon: -5.44881 },
  { lat: 57.4246, lon: -5.44828 },
  { lat: 57.4239, lon: -5.44818 },
  { lat: 57.42191, lon: -5.44861 },
  { lat: 57.42068, lon: -5.45011 },
  { lat: 57.42051, lon: -5.44958 },
  { lat: 57.42165, lon: -5.44745 },
  { lat: 57.4216, lon: -5.44621 },
  { lat: 57.42287, lon: -5.44635 },
  { lat: 57.42172, lon: -5.4459 },
  { lat: 57.42214, lon: -5.44276 },
  { lat: 57.42269, lon: -5.44219 },
  { lat: 57.4221, lon: -5.44251 },
  { lat: 57.42163, lon: -5.44556 },
  { lat: 57.42066, lon: -5.44639 },
  { lat: 57.41953, lon: -5.44476 },
  { lat: 57.42045, lon: -5.44389 },
  { lat: 57.41937, lon: -5.4447 },
  { lat: 57.41893, lon: -5.44362 },
  { lat: 57.42025, lon: -5.44119 },
  { lat: 57.4199, lon: -5.44093 },
  { lat: 57.42004, lon: -5.4399 },
  { lat: 57.41802, lon: -5.44151 },
  { lat: 57.41548, lon: -5.44158 },
  { lat: 57.41503, lon: -5.44057 },
  { lat: 57.41588, lon: -5.44052 },
  { lat: 57.41556, lon: -5.43921 },
  { lat: 57.41615, lon: -5.43763 },
  { lat: 57.41546, lon: -5.43897 },
  { lat: 57.4157, lon: -5.44049 },
  { lat: 57.41545, lon: -5.4401 },
  { lat: 57.41393, lon: -5.44058 },
  { lat: 57.41524, lon: -5.43596 },
  { lat: 57.41524, lon: -5.43679 },
  { lat: 57.41433, lon: -5.43824 },
  { lat: 57.41439, lon: -5.43949 },
  { lat: 57.41235, lon: -5.4418 },
  { lat: 57.41208, lon: -5.44324 },
  { lat: 57.41073, lon: -5.44382 },
  { lat: 57.41073, lon: -5.4446 },
  { lat: 57.40954, lon: -5.44495 },
  { lat: 57.40949, lon: -5.44545 },
  { lat: 57.40853, lon: -5.44536 },
  { lat: 57.40756, lon: -5.44883 },
  { lat: 57.40503, lon: -5.45299 },
  { lat: 57.40146, lon: -5.45488 },
  { lat: 57.40059, lon: -5.45589 },
  { lat: 57.39791, lon: -5.4563 },
  { lat: 57.3969, lon: -5.45779 },
  { lat: 57.39394, lon: -5.45907 },
  { lat: 57.39346, lon: -5.45899 },
  { lat: 57.39356, lon: -5.45862 },
  { lat: 57.39587, lon: -5.45785 },
  { lat: 57.39457, lon: -5.45756 },
  { lat: 57.39443, lon: -5.45653 },
  { lat: 57.39477, lon: -5.45699 },
  { lat: 57.39589, lon: -5.457 },
  { lat: 57.39589, lon: -5.4561 },
  { lat: 57.39434, lon: -5.45577 },
  { lat: 57.39268, lon: -5.45937 },
  { lat: 57.39123, lon: -5.45715 },
  { lat: 57.39131, lon: -5.45821 },
  { lat: 57.39097, lon: -5.45799 },
  { lat: 57.39047, lon: -5.45983 },
  { lat: 57.38904, lon: -5.46042 },
  { lat: 57.38792, lon: -5.46632 },
  { lat: 57.38745, lon: -5.46625 },
  { lat: 57.38644, lon: -5.46737 },
  { lat: 57.38511, lon: -5.47009 },
  { lat: 57.38287, lon: -5.47221 },
  { lat: 57.37949, lon: -5.48126 },
  { lat: 57.37674, lon: -5.48599 },
  { lat: 57.37473, lon: -5.49471 },
  { lat: 57.37249, lon: -5.49777 },
  { lat: 57.37161, lon: -5.50033 },
  { lat: 57.37064, lon: -5.50106 },
  { lat: 57.36951, lon: -5.50114 },
  { lat: 57.36719, lon: -5.5042 },
  { lat: 57.36511, lon: -5.50591 },
  { lat: 57.36407, lon: -5.50814 },
  { lat: 57.36339, lon: -5.5119 },
  { lat: 57.36202, lon: -5.51267 },
  { lat: 57.3614, lon: -5.51363 },
  { lat: 57.36153, lon: -5.51828 },
  { lat: 57.35861, lon: -5.52127 },
  { lat: 57.35797, lon: -5.52489 },
  { lat: 57.35659, lon: -5.52588 },
  { lat: 57.35277, lon: -5.53512 },
  { lat: 57.35219, lon: -5.53825 },
  { lat: 57.35202, lon: -5.54507 },
  { lat: 57.35279, lon: -5.54895 },
  { lat: 57.35248, lon: -5.55032 },
  { lat: 57.35261, lon: -5.55077 },
  { lat: 57.35288, lon: -5.5505 },
  { lat: 57.35313, lon: -5.55648 },
  { lat: 57.35413, lon: -5.56114 },
  { lat: 57.35409, lon: -5.5666 },
  { lat: 57.35304, lon: -5.57111 },
  { lat: 57.35366, lon: -5.5728 },
  { lat: 57.35373, lon: -5.57821 },
  { lat: 57.35198, lon: -5.58287 },
  { lat: 57.34912, lon: -5.5866 },
  { lat: 57.34775, lon: -5.58718 },
  { lat: 57.34556, lon: -5.58663 },
  { lat: 57.34469, lon: -5.58712 },
  { lat: 57.34483, lon: -5.58636 },
  { lat: 57.34421, lon: -5.5852 },
  { lat: 57.34399, lon: -5.58778 },
  { lat: 57.34435, lon: -5.58712 },
  { lat: 57.34453, lon: -5.58741 },
  { lat: 57.34338, lon: -5.59459 },
  { lat: 57.34349, lon: -5.6001 },
  { lat: 57.34198, lon: -5.60358 },
  { lat: 57.34062, lon: -5.60987 },
  { lat: 57.33865, lon: -5.61421 },
  { lat: 57.33808, lon: -5.61652 },
  { lat: 57.33828, lon: -5.61739 },
  { lat: 57.3377, lon: -5.61818 },
  { lat: 57.3376, lon: -5.62018 },
  { lat: 57.33736, lon: -5.61986 },
  { lat: 57.33721, lon: -5.62036 },
  { lat: 57.33743, lon: -5.62135 },
  { lat: 57.33762, lon: -5.62025 },
  { lat: 57.33894, lon: -5.62188 },
  { lat: 57.33868, lon: -5.62869 },
  { lat: 57.3392, lon: -5.63006 },
  { lat: 57.33885, lon: -5.63599 },
  { lat: 57.33752, lon: -5.63787 },
  { lat: 57.33705, lon: -5.63743 },
  { lat: 57.33616, lon: -5.63806 },
  { lat: 57.33674, lon: -5.63711 },
  { lat: 57.33646, lon: -5.63637 },
  { lat: 57.33569, lon: -5.63727 },
  { lat: 57.33564, lon: -5.63841 },
  { lat: 57.33618, lon: -5.63827 },
  { lat: 57.33555, lon: -5.64104 },
  { lat: 57.33549, lon: -5.64615 },
  { lat: 57.3345, lon: -5.64982 },
  { lat: 57.33481, lon: -5.66134 },
  { lat: 57.33544, lon: -5.65984 },
  { lat: 57.33485, lon: -5.65944 },
  { lat: 57.33483, lon: -5.65877 },
  { lat: 57.33528, lon: -5.65447 },
  { lat: 57.33757, lon: -5.65083 },
  { lat: 57.33913, lon: -5.65114 },
  { lat: 57.33971, lon: -5.65038 },
  { lat: 57.34081, lon: -5.64809 },
  { lat: 57.34061, lon: -5.6474 },
  { lat: 57.33982, lon: -5.64763 },
  { lat: 57.33999, lon: -5.64598 },
  { lat: 57.34037, lon: -5.64582 },
  { lat: 57.34063, lon: -5.64657 },
  { lat: 57.34077, lon: -5.64549 },
  { lat: 57.34186, lon: -5.64477 },
  { lat: 57.34215, lon: -5.6458 },
  { lat: 57.34177, lon: -5.64856 },
  { lat: 57.34219, lon: -5.64887 },
  { lat: 57.34253, lon: -5.64564 },
  { lat: 57.34359, lon: -5.64522 },
  { lat: 57.34414, lon: -5.64291 },
  { lat: 57.34463, lon: -5.6435 },
  { lat: 57.34573, lon: -5.64352 },
  { lat: 57.34609, lon: -5.6449 },
  { lat: 57.34593, lon: -5.64618 },
  { lat: 57.34511, lon: -5.6472 },
  { lat: 57.34555, lon: -5.64812 },
  { lat: 57.34559, lon: -5.65089 },
  { lat: 57.34486, lon: -5.65232 },
  { lat: 57.34413, lon: -5.65226 },
  { lat: 57.34389, lon: -5.65288 },
  { lat: 57.34429, lon: -5.65273 },
  { lat: 57.34434, lon: -5.65434 },
  { lat: 57.34563, lon: -5.65403 },
  { lat: 57.3455, lon: -5.65941 },
  { lat: 57.34484, lon: -5.66019 },
  { lat: 57.34416, lon: -5.65935 },
  { lat: 57.34241, lon: -5.65941 },
  { lat: 57.34202, lon: -5.65737 },
  { lat: 57.34081, lon: -5.6586 },
  { lat: 57.34081, lon: -5.66028 },
  { lat: 57.34148, lon: -5.66165 },
  { lat: 57.34131, lon: -5.66286 },
  { lat: 57.34037, lon: -5.66181 },
  { lat: 57.34003, lon: -5.66194 },
  { lat: 57.33994, lon: -5.66397 },
  { lat: 57.34114, lon: -5.66745 },
  { lat: 57.34111, lon: -5.66882 },
  { lat: 57.34095, lon: -5.6703 },
  { lat: 57.33997, lon: -5.67226 },
  { lat: 57.33986, lon: -5.67456 },
  { lat: 57.33919, lon: -5.67499 },
  { lat: 57.33995, lon: -5.67627 },
  { lat: 57.33949, lon: -5.67729 },
  { lat: 57.34013, lon: -5.67769 },
  { lat: 57.33909, lon: -5.68035 },
  { lat: 57.33922, lon: -5.68098 },
  { lat: 57.34092, lon: -5.6806 },
  { lat: 57.34172, lon: -5.68167 },
  { lat: 57.34193, lon: -5.68392 },
  { lat: 57.34155, lon: -5.68583 },
  { lat: 57.33965, lon: -5.68588 },
  { lat: 57.33941, lon: -5.68506 },
  { lat: 57.33894, lon: -5.68531 },
  { lat: 57.33817, lon: -5.68424 },
  { lat: 57.33738, lon: -5.68437 },
  { lat: 57.33718, lon: -5.68397 },
  { lat: 57.33705, lon: -5.68498 },
  { lat: 57.33628, lon: -5.68456 },
  { lat: 57.33619, lon: -5.68284 },
  { lat: 57.33687, lon: -5.68308 },
  { lat: 57.33835, lon: -5.68097 },
  { lat: 57.3374, lon: -5.67822 },
  { lat: 57.33642, lon: -5.67872 },
  { lat: 57.33516, lon: -5.67763 },
  { lat: 57.33415, lon: -5.67791 },
  { lat: 57.33431, lon: -5.67898 },
  { lat: 57.3338, lon: -5.67984 },
  { lat: 57.33408, lon: -5.68157 },
  { lat: 57.33358, lon: -5.68251 },
  { lat: 57.33135, lon: -5.68357 },
  { lat: 57.33008, lon: -5.68272 },
  { lat: 57.32952, lon: -5.68127 },
  { lat: 57.32951, lon: -5.68189 },
  { lat: 57.32915, lon: -5.68172 },
  { lat: 57.32889, lon: -5.68235 },
  { lat: 57.32955, lon: -5.68328 },
  { lat: 57.32909, lon: -5.68377 },
  { lat: 57.32883, lon: -5.68263 },
  { lat: 57.32826, lon: -5.683 },
  { lat: 57.32753, lon: -5.68044 },
  { lat: 57.32779, lon: -5.67843 },
  { lat: 57.32734, lon: -5.67741 },
  { lat: 57.32757, lon: -5.67397 },
  { lat: 57.32798, lon: -5.67347 },
  { lat: 57.32754, lon: -5.673 },
  { lat: 57.32709, lon: -5.67362 },
  { lat: 57.32676, lon: -5.67254 },
  { lat: 57.32633, lon: -5.67251 },
  { lat: 57.32569, lon: -5.67344 },
  { lat: 57.3257, lon: -5.67572 },
  { lat: 57.32523, lon: -5.67699 },
  { lat: 57.32499, lon: -5.67613 },
  { lat: 57.32453, lon: -5.68007 },
  { lat: 57.32396, lon: -5.68082 },
  { lat: 57.3246, lon: -5.68298 },
  { lat: 57.32445, lon: -5.68587 },
  { lat: 57.32356, lon: -5.68823 },
  { lat: 57.32268, lon: -5.68842 },
  { lat: 57.32369, lon: -5.68861 },
  { lat: 57.32442, lon: -5.68816 },
  { lat: 57.32451, lon: -5.6899 },
  { lat: 57.32571, lon: -5.69164 },
  { lat: 57.3257, lon: -5.69461 },
  { lat: 57.32534, lon: -5.69483 },
  { lat: 57.32557, lon: -5.69534 },
  { lat: 57.32674, lon: -5.69557 },
  { lat: 57.3267, lon: -5.69718 },
  { lat: 57.32603, lon: -5.69782 },
  { lat: 57.3256, lon: -5.69669 },
  { lat: 57.32534, lon: -5.69992 },
  { lat: 57.32412, lon: -5.70202 },
  { lat: 57.32177, lon: -5.70291 },
  { lat: 57.32179, lon: -5.70182 },
  { lat: 57.32007, lon: -5.70131 },
  { lat: 57.31934, lon: -5.70335 },
  { lat: 57.31901, lon: -5.70349 },
  { lat: 57.31887, lon: -5.70212 },
  { lat: 57.31742, lon: -5.70274 },
  { lat: 57.31739, lon: -5.70342 },
  { lat: 57.31797, lon: -5.70391 },
  { lat: 57.31753, lon: -5.70416 },
  { lat: 57.3179, lon: -5.70572 },
  { lat: 57.31718, lon: -5.70681 },
  { lat: 57.31776, lon: -5.70949 },
  { lat: 57.31819, lon: -5.70931 },
  { lat: 57.318, lon: -5.70807 },
  { lat: 57.31845, lon: -5.7075 },
  { lat: 57.31861, lon: -5.70988 },
  { lat: 57.31794, lon: -5.71109 },
  { lat: 57.31793, lon: -5.7101 },
  { lat: 57.31742, lon: -5.71007 },
  { lat: 57.31663, lon: -5.71119 },
  { lat: 57.31634, lon: -5.71283 },
  { lat: 57.31709, lon: -5.71222 },
  { lat: 57.31733, lon: -5.71269 },
  { lat: 57.31767, lon: -5.71209 },
  { lat: 57.3184, lon: -5.71221 },
  { lat: 57.31862, lon: -5.71347 },
  { lat: 57.31818, lon: -5.71499 },
  { lat: 57.31756, lon: -5.71552 },
  { lat: 57.31718, lon: -5.71526 },
  { lat: 57.31727, lon: -5.71296 },
  { lat: 57.31656, lon: -5.71396 },
  { lat: 57.31648, lon: -5.71328 },
  { lat: 57.31581, lon: -5.7135 },
  { lat: 57.31522, lon: -5.717 },
  { lat: 57.31419, lon: -5.7174 },
  { lat: 57.31417, lon: -5.71835 },
  { lat: 57.31312, lon: -5.71945 },
  { lat: 57.31159, lon: -5.7191 },
  { lat: 57.31158, lon: -5.71958 },
  { lat: 57.31209, lon: -5.71961 },
  { lat: 57.31125, lon: -5.72286 },
  { lat: 57.31103, lon: -5.72143 },
  { lat: 57.31052, lon: -5.72139 },
  { lat: 57.31132, lon: -5.72003 },
  { lat: 57.31047, lon: -5.71886 },
  { lat: 57.30987, lon: -5.72122 },
  { lat: 57.30937, lon: -5.72177 },
  { lat: 57.30895, lon: -5.72076 },
  { lat: 57.30868, lon: -5.72128 },
  { lat: 57.30891, lon: -5.72458 },
  { lat: 57.3084, lon: -5.72455 },
  { lat: 57.30817, lon: -5.72358 },
  { lat: 57.30815, lon: -5.72453 },
  { lat: 57.30737, lon: -5.72494 },
  { lat: 57.30752, lon: -5.72401 },
  { lat: 57.30648, lon: -5.7244 },
  { lat: 57.30657, lon: -5.7263 },
  { lat: 57.3045, lon: -5.7271 },
  { lat: 57.30444, lon: -5.72261 },
  { lat: 57.3038, lon: -5.71972 },
  { lat: 57.30271, lon: -5.71801 },
  { lat: 57.30409, lon: -5.71914 },
  { lat: 57.30419, lon: -5.72013 },
  { lat: 57.30441, lon: -5.71692 },
  { lat: 57.30372, lon: -5.71637 },
  { lat: 57.3032, lon: -5.71723 },
  { lat: 57.30304, lon: -5.71663 },
  { lat: 57.30248, lon: -5.717 },
  { lat: 57.30252, lon: -5.71816 },
  { lat: 57.30142, lon: -5.71853 },
  { lat: 57.29982, lon: -5.72439 },
  { lat: 57.29756, lon: -5.72848 },
  { lat: 57.29779, lon: -5.72944 },
  { lat: 57.2965, lon: -5.72982 },
  { lat: 57.29652, lon: -5.72887 },
  { lat: 57.2955, lon: -5.72903 },
  { lat: 57.29399, lon: -5.72774 },
  { lat: 57.29388, lon: -5.72678 },
  { lat: 57.29325, lon: -5.72626 },
  { lat: 57.29294, lon: -5.72407 },
  { lat: 57.29278, lon: -5.72434 },
  { lat: 57.29228, lon: -5.72383 },
  { lat: 57.29231, lon: -5.72651 },
  { lat: 57.29272, lon: -5.72717 },
  { lat: 57.29171, lon: -5.72662 },
  { lat: 57.2915, lon: -5.72424 },
  { lat: 57.29071, lon: -5.72513 },
  { lat: 57.29038, lon: -5.72274 },
  { lat: 57.28975, lon: -5.72222 },
  { lat: 57.28931, lon: -5.72075 },
  { lat: 57.28797, lon: -5.72078 },
  { lat: 57.28676, lon: -5.72188 },
  { lat: 57.28659, lon: -5.72119 },
  { lat: 57.2859, lon: -5.72265 },
  { lat: 57.28443, lon: -5.71917 },
  { lat: 57.2835, lon: -5.71819 },
  { lat: 57.28474, lon: -5.72327 },
  { lat: 57.28366, lon: -5.7253 },
  { lat: 57.28386, lon: -5.7256 },
  { lat: 57.28523, lon: -5.72511 },
  { lat: 57.28509, lon: -5.72711 },
  { lat: 57.28545, lon: -5.72699 },
  { lat: 57.28549, lon: -5.72744 },
  { lat: 57.28488, lon: -5.72871 },
  { lat: 57.28488, lon: -5.73123 },
  { lat: 57.28362, lon: -5.73409 },
  { lat: 57.28293, lon: -5.73335 },
  { lat: 57.28295, lon: -5.73195 },
  { lat: 57.28213, lon: -5.73149 },
  { lat: 57.28179, lon: -5.73231 },
  { lat: 57.28106, lon: -5.73246 },
  { lat: 57.28074, lon: -5.73054 },
  { lat: 57.28142, lon: -5.72962 },
  { lat: 57.28132, lon: -5.72717 },
  { lat: 57.28063, lon: -5.72735 },
  { lat: 57.28066, lon: -5.72595 },
  { lat: 57.27981, lon: -5.72612 },
  { lat: 57.27986, lon: -5.72386 },
  { lat: 57.27959, lon: -5.72292 },
  { lat: 57.27916, lon: -5.72343 },
  { lat: 57.27985, lon: -5.72099 },
  { lat: 57.27981, lon: -5.71756 },
  { lat: 57.28022, lon: -5.71665 },
  { lat: 57.27981, lon: -5.7159 },
  { lat: 57.28007, lon: -5.71443 },
  { lat: 57.27916, lon: -5.71427 },
  { lat: 57.27923, lon: -5.71313 },
  { lat: 57.28014, lon: -5.71328 },
  { lat: 57.27972, lon: -5.71203 },
  { lat: 57.27956, lon: -5.71238 },
  { lat: 57.27962, lon: -5.70927 },
  { lat: 57.28021, lon: -5.70773 },
  { lat: 57.28064, lon: -5.70812 },
  { lat: 57.28078, lon: -5.70781 },
  { lat: 57.28057, lon: -5.70701 },
  { lat: 57.28022, lon: -5.70713 },
  { lat: 57.28, lon: -5.70412 },
  { lat: 57.28066, lon: -5.69638 },
  { lat: 57.28115, lon: -5.69454 },
  { lat: 57.28227, lon: -5.69337 },
  { lat: 57.28274, lon: -5.69201 },
  { lat: 57.28217, lon: -5.6896 },
  { lat: 57.28227, lon: -5.6876 },
  { lat: 57.2811, lon: -5.68581 },
  { lat: 57.28125, lon: -5.68251 },
  { lat: 57.28088, lon: -5.68231 },
  { lat: 57.28059, lon: -5.67756 },
  { lat: 57.28102, lon: -5.67566 },
  { lat: 57.28063, lon: -5.67328 },
  { lat: 57.28137, lon: -5.67198 },
  { lat: 57.28127, lon: -5.66874 },
  { lat: 57.28174, lon: -5.66763 },
  { lat: 57.28166, lon: -5.66326 },
  { lat: 57.28285, lon: -5.6587 },
  { lat: 57.28416, lon: -5.65702 },
  { lat: 57.28508, lon: -5.65444 },
  { lat: 57.28665, lon: -5.64689 },
  { lat: 57.2862, lon: -5.64449 },
  { lat: 57.28553, lon: -5.64405 },
  { lat: 57.28418, lon: -5.63963 },
  { lat: 57.28359, lon: -5.639 },
  { lat: 57.28357, lon: -5.63994 },
  { lat: 57.28306, lon: -5.6399 },
  { lat: 57.28308, lon: -5.63896 },
  { lat: 57.28231, lon: -5.63891 },
  { lat: 57.2826, lon: -5.63751 },
  { lat: 57.28311, lon: -5.63754 },
  { lat: 57.28217, lon: -5.63104 },
  { lat: 57.28211, lon: -5.62699 },
  { lat: 57.28091, lon: -5.62464 },
  { lat: 57.28041, lon: -5.6252 },
  { lat: 57.27929, lon: -5.62478 },
  { lat: 57.2785, lon: -5.62516 },
  { lat: 57.27751, lon: -5.62367 },
  { lat: 57.27599, lon: -5.62285 },
  { lat: 57.27602, lon: -5.62143 },
  { lat: 57.27524, lon: -5.62161 },
  { lat: 57.27527, lon: -5.62043 },
  { lat: 57.27438, lon: -5.6199 },
  { lat: 57.27584, lon: -5.61149 },
  { lat: 57.27734, lon: -5.60687 },
  { lat: 57.27785, lon: -5.6069 },
  { lat: 57.27829, lon: -5.59842 },
  { lat: 57.27778, lon: -5.59839 },
  { lat: 57.2778, lon: -5.59697 },
  { lat: 57.27704, lon: -5.59691 },
  { lat: 57.27681, lon: -5.59572 },
  { lat: 57.27504, lon: -5.59465 },
  { lat: 57.27298, lon: -5.59497 },
  { lat: 57.27222, lon: -5.59445 },
  { lat: 57.27094, lon: -5.59459 },
  { lat: 57.27084, lon: -5.59317 },
  { lat: 57.271, lon: -5.59176 },
  { lat: 57.27176, lon: -5.59205 },
  { lat: 57.27203, lon: -5.59136 },
  { lat: 57.27152, lon: -5.59109 },
  { lat: 57.27129, lon: -5.58989 },
  { lat: 57.27078, lon: -5.58985 },
  { lat: 57.2708, lon: -5.58891 },
  { lat: 57.27181, lon: -5.58945 },
  { lat: 57.27184, lon: -5.58804 },
  { lat: 57.27312, lon: -5.58813 },
  { lat: 57.27417, lon: -5.58064 },
  { lat: 57.27498, lon: -5.57857 },
  { lat: 57.27435, lon: -5.57687 },
  { lat: 57.27357, lon: -5.57741 },
  { lat: 57.27271, lon: -5.57734 },
  { lat: 57.27346, lon: -5.5716 },
  { lat: 57.27423, lon: -5.57166 },
  { lat: 57.27438, lon: -5.57025 },
  { lat: 57.27532, lon: -5.56819 },
  { lat: 57.27584, lon: -5.56799 },
  { lat: 57.27587, lon: -5.56657 },
  { lat: 57.27768, lon: -5.56575 },
  { lat: 57.27771, lon: -5.56433 },
  { lat: 57.27927, lon: -5.56302 },
  { lat: 57.28004, lon: -5.55962 },
  { lat: 57.27901, lon: -5.55949 },
  { lat: 57.27764, lon: -5.56149 },
  { lat: 57.27729, lon: -5.55958 },
  { lat: 57.2778, lon: -5.55985 },
  { lat: 57.27816, lon: -5.55919 },
  { lat: 57.27742, lon: -5.55846 },
  { lat: 57.27673, lon: -5.55575 },
  { lat: 57.27659, lon: -5.55007 },
  { lat: 57.27674, lon: -5.54913 },
  { lat: 57.2775, lon: -5.54919 },
  { lat: 57.27768, lon: -5.54683 },
  { lat: 57.27891, lon: -5.54472 },
  { lat: 57.28007, lon: -5.5391 },
  { lat: 57.28088, lon: -5.53775 },
  { lat: 57.27952, lon: -5.53337 },
  { lat: 57.28029, lon: -5.53204 },
  { lat: 57.28107, lon: -5.52635 },
  { lat: 57.28061, lon: -5.52311 },
  { lat: 57.2792, lon: -5.52187 },
  { lat: 57.27798, lon: -5.52287 },
  { lat: 57.27701, lon: -5.51997 },
  { lat: 57.27836, lon: -5.51977 },
  { lat: 57.27856, lon: -5.51927 },
  { lat: 57.28209, lon: -5.51979 },
  { lat: 57.28365, lon: -5.51905 },
  { lat: 57.28834, lon: -5.51265 },
  { lat: 57.28899, lon: -5.51346 },
  { lat: 57.28943, lon: -5.51703 },
  { lat: 57.29003, lon: -5.51236 },
  { lat: 57.29161, lon: -5.50821 },
  { lat: 57.29287, lon: -5.49888 },
  { lat: 57.29476, lon: -5.49684 },
  { lat: 57.29655, lon: -5.49359 },
  { lat: 57.29824, lon: -5.49195 },
  { lat: 57.29842, lon: -5.49088 },
  { lat: 57.30009, lon: -5.4886 },
  { lat: 57.30204, lon: -5.48874 },
  { lat: 57.3052, lon: -5.49056 },
  { lat: 57.30609, lon: -5.49036 },
  { lat: 57.30822, lon: -5.48716 },
  { lat: 57.30834, lon: -5.4849 },
  { lat: 57.31043, lon: -5.48399 },
  { lat: 57.31099, lon: -5.48193 },
  { lat: 57.31204, lon: -5.48058 },
  { lat: 57.31376, lon: -5.47363 },
  { lat: 57.31324, lon: -5.47077 },
  { lat: 57.31231, lon: -5.46978 },
  { lat: 57.31231, lon: -5.46918 },
  { lat: 57.31396, lon: -5.4677 },
  { lat: 57.3151, lon: -5.46776 },
  { lat: 57.31542, lon: -5.46706 },
  { lat: 57.3159, lon: -5.46149 },
  { lat: 57.31548, lon: -5.46021 },
  { lat: 57.31545, lon: -5.45529 },
  { lat: 57.31476, lon: -5.45396 },
  { lat: 57.31501, lon: -5.45162 },
  { lat: 57.31596, lon: -5.45015 },
  { lat: 57.31639, lon: -5.44613 },
  { lat: 57.31466, lon: -5.44137 },
  { lat: 57.31375, lon: -5.44031 },
  { lat: 57.31244, lon: -5.44169 },
  { lat: 57.31154, lon: -5.44415 },
  { lat: 57.31182, lon: -5.44794 },
  { lat: 57.31001, lon: -5.45347 },
  { lat: 57.30962, lon: -5.46054 },
  { lat: 57.3084, lon: -5.4677 },
  { lat: 57.30977, lon: -5.47241 },
  { lat: 57.30931, lon: -5.47427 },
  { lat: 57.3075, lon: -5.47695 },
  { lat: 57.30709, lon: -5.48242 },
  { lat: 57.30605, lon: -5.48636 },
  { lat: 57.3045, lon: -5.48806 },
  { lat: 57.30307, lon: -5.48671 },
  { lat: 57.30157, lon: -5.48664 },
  { lat: 57.3003, lon: -5.48576 },
  { lat: 57.29972, lon: -5.48571 },
  { lat: 57.29922, lon: -5.48635 },
  { lat: 57.29716, lon: -5.48619 },
  { lat: 57.29608, lon: -5.48817 },
  { lat: 57.29402, lon: -5.49032 },
  { lat: 57.29367, lon: -5.49141 },
  { lat: 57.29418, lon: -5.49292 },
  { lat: 57.29379, lon: -5.49404 },
  { lat: 57.29163, lon: -5.49563 },
  { lat: 57.28995, lon: -5.49575 },
  { lat: 57.28844, lon: -5.49745 },
  { lat: 57.28872, lon: -5.49973 },
  { lat: 57.28751, lon: -5.50353 },
  { lat: 57.28543, lon: -5.50614 },
  { lat: 57.28529, lon: -5.50773 },
  { lat: 57.28428, lon: -5.50817 },
  { lat: 57.28192, lon: -5.51508 },
  { lat: 57.27955, lon: -5.51612 },
  { lat: 57.27766, lon: -5.5156 },
  { lat: 57.2772, lon: -5.51495 },
  { lat: 57.27712, lon: -5.516 },
  { lat: 57.27632, lon: -5.51447 },
  { lat: 57.27524, lon: -5.51507 },
  { lat: 57.2745, lon: -5.51435 },
  { lat: 57.27427, lon: -5.5149 },
  { lat: 57.27435, lon: -5.51392 },
  { lat: 57.27213, lon: -5.51266 },
  { lat: 57.27141, lon: -5.50989 },
  { lat: 57.27005, lon: -5.50895 },
  { lat: 57.26916, lon: -5.50738 },
  { lat: 57.26816, lon: -5.50708 },
  { lat: 57.2667, lon: -5.50447 },
  { lat: 57.26485, lon: -5.50368 },
  { lat: 57.26455, lon: -5.50248 },
  { lat: 57.26241, lon: -5.4996 },
  { lat: 57.26085, lon: -5.49317 },
  { lat: 57.25812, lon: -5.48985 },
  { lat: 57.25691, lon: -5.48293 },
  { lat: 57.25574, lon: -5.48015 },
  { lat: 57.2531, lon: -5.47591 },
  { lat: 57.24982, lon: -5.47333 },
  { lat: 57.24943, lon: -5.47196 },
  { lat: 57.24738, lon: -5.46968 },
  { lat: 57.24688, lon: -5.46755 },
  { lat: 57.24645, lon: -5.46715 },
  { lat: 57.2461, lon: -5.46741 },
  { lat: 57.24527, lon: -5.46573 },
  { lat: 57.24434, lon: -5.4654 },
  { lat: 57.2433, lon: -5.46418 },
  { lat: 57.2433, lon: -5.46295 },
  { lat: 57.24269, lon: -5.46266 },
  { lat: 57.24241, lon: -5.46308 },
  { lat: 57.24237, lon: -5.46209 },
  { lat: 57.24189, lon: -5.46174 },
  { lat: 57.24146, lon: -5.46214 },
  { lat: 57.24133, lon: -5.46029 },
  { lat: 57.24075, lon: -5.45983 },
  { lat: 57.24032, lon: -5.45721 },
  { lat: 57.23981, lon: -5.45674 },
  { lat: 57.23978, lon: -5.45433 },
  { lat: 57.23845, lon: -5.45337 },
  { lat: 57.23849, lon: -5.45176 },
  { lat: 57.2373, lon: -5.45035 },
  { lat: 57.237, lon: -5.4464 },
  { lat: 57.23598, lon: -5.44496 },
  { lat: 57.23659, lon: -5.44229 },
  { lat: 57.23639, lon: -5.43932 },
  { lat: 57.23326, lon: -5.42587 },
  { lat: 57.2327, lon: -5.41858 },
  { lat: 57.2322, lon: -5.41661 },
  { lat: 57.23148, lon: -5.41591 },
  { lat: 57.22995, lon: -5.41634 },
  { lat: 57.22934, lon: -5.41592 },
  { lat: 57.23089, lon: -5.41376 },
  { lat: 57.23248, lon: -5.40805 },
  { lat: 57.23331, lon: -5.40752 },
  { lat: 57.23338, lon: -5.40601 },
  { lat: 57.23229, lon: -5.4041 },
  { lat: 57.23289, lon: -5.40471 },
  { lat: 57.23324, lon: -5.40443 },
  { lat: 57.23355, lon: -5.40237 },
  { lat: 57.23447, lon: -5.40068 },
  { lat: 57.23537, lon: -5.40088 },
  { lat: 57.23538, lon: -5.40213 },
  { lat: 57.23662, lon: -5.39677 },
  { lat: 57.23626, lon: -5.39528 },
  { lat: 57.23649, lon: -5.39711 },
  { lat: 57.236, lon: -5.39799 },
  { lat: 57.23579, lon: -5.39524 },
  { lat: 57.23583, lon: -5.39811 },
  { lat: 57.23543, lon: -5.39858 },
  { lat: 57.23487, lon: -5.39671 },
  { lat: 57.23579, lon: -5.39504 },
  { lat: 57.23562, lon: -5.39218 },
  { lat: 57.23548, lon: -5.39569 },
  { lat: 57.23472, lon: -5.39635 },
  { lat: 57.23508, lon: -5.39877 },
  { lat: 57.23482, lon: -5.3982 },
  { lat: 57.23467, lon: -5.39891 },
  { lat: 57.23446, lon: -5.39808 },
  { lat: 57.2345, lon: -5.39921 },
  { lat: 57.23438, lon: -5.39854 },
  { lat: 57.23387, lon: -5.39881 },
  { lat: 57.23459, lon: -5.39578 },
  { lat: 57.23425, lon: -5.39467 },
  { lat: 57.23429, lon: -5.39612 },
  { lat: 57.23341, lon: -5.39835 },
  { lat: 57.23361, lon: -5.39752 },
  { lat: 57.23333, lon: -5.39799 },
  { lat: 57.2332, lon: -5.39748 },
  { lat: 57.2339, lon: -5.39587 },
  { lat: 57.23343, lon: -5.39669 },
  { lat: 57.23358, lon: -5.39474 },
  { lat: 57.2334, lon: -5.39679 },
  { lat: 57.23277, lon: -5.39741 },
  { lat: 57.23309, lon: -5.39684 },
  { lat: 57.23282, lon: -5.39657 },
  { lat: 57.23248, lon: -5.39695 },
  { lat: 57.2325, lon: -5.39617 },
  { lat: 57.23309, lon: -5.39494 },
  { lat: 57.23273, lon: -5.39546 },
  { lat: 57.23198, lon: -5.39517 },
  { lat: 57.23185, lon: -5.39602 },
  { lat: 57.23188, lon: -5.39426 },
  { lat: 57.23133, lon: -5.39545 },
  { lat: 57.23208, lon: -5.39371 },
  { lat: 57.23139, lon: -5.39274 },
  { lat: 57.2315, lon: -5.39412 },
  { lat: 57.22844, lon: -5.40141 },
  { lat: 57.22845, lon: -5.40387 },
  { lat: 57.22848, lon: -5.40423 },
  { lat: 57.2297, lon: -5.40275 },
  { lat: 57.23054, lon: -5.40257 },
  { lat: 57.2319, lon: -5.40388 },
  { lat: 57.2308, lon: -5.403 },
  { lat: 57.22955, lon: -5.40316 },
  { lat: 57.22805, lon: -5.40587 },
  { lat: 57.22569, lon: -5.40779 },
  { lat: 57.22482, lon: -5.41014 },
  { lat: 57.2251, lon: -5.4113 },
  { lat: 57.22585, lon: -5.41087 },
  { lat: 57.22567, lon: -5.41361 },
  { lat: 57.22511, lon: -5.41518 },
  { lat: 57.22432, lon: -5.4139 },
  { lat: 57.22399, lon: -5.41428 },
  { lat: 57.2228, lon: -5.41846 },
  { lat: 57.22034, lon: -5.41882 },
  { lat: 57.22004, lon: -5.41788 },
  { lat: 57.21934, lon: -5.41789 },
  { lat: 57.21809, lon: -5.41933 },
  { lat: 57.21739, lon: -5.42128 },
  { lat: 57.21768, lon: -5.42271 },
  { lat: 57.21799, lon: -5.42186 },
  { lat: 57.21681, lon: -5.42716 },
  { lat: 57.21415, lon: -5.42512 },
  { lat: 57.2137, lon: -5.42308 },
  { lat: 57.21386, lon: -5.42542 },
  { lat: 57.2148, lon: -5.42756 },
  { lat: 57.213, lon: -5.42672 },
  { lat: 57.2124, lon: -5.43025 },
  { lat: 57.21318, lon: -5.43063 },
  { lat: 57.21205, lon: -5.43108 },
  { lat: 57.21217, lon: -5.43298 },
  { lat: 57.21518, lon: -5.43729 },
  { lat: 57.21809, lon: -5.4435 },
  { lat: 57.2195, lon: -5.44438 },
  { lat: 57.21991, lon: -5.44539 },
  { lat: 57.22253, lon: -5.44689 },
  { lat: 57.22398, lon: -5.45007 },
  { lat: 57.22421, lon: -5.45202 },
  { lat: 57.22867, lon: -5.46188 },
  { lat: 57.22913, lon: -5.46415 },
  { lat: 57.22991, lon: -5.46599 },
  { lat: 57.23077, lon: -5.46671 },
  { lat: 57.23058, lon: -5.46897 },
  { lat: 57.23202, lon: -5.4741 },
  { lat: 57.23347, lon: -5.47711 },
  { lat: 57.23497, lon: -5.47829 },
  { lat: 57.23592, lon: -5.48128 },
  { lat: 57.23718, lon: -5.48223 },
  { lat: 57.23893, lon: -5.48569 },
  { lat: 57.24077, lon: -5.48564 },
  { lat: 57.242, lon: -5.488 },
  { lat: 57.24267, lon: -5.48796 },
  { lat: 57.24338, lon: -5.48892 },
  { lat: 57.24464, lon: -5.49185 },
  { lat: 57.24549, lon: -5.49205 },
  { lat: 57.24638, lon: -5.4955 },
  { lat: 57.24775, lon: -5.49687 },
  { lat: 57.24858, lon: -5.49922 },
  { lat: 57.25004, lon: -5.50035 },
  { lat: 57.25132, lon: -5.50457 },
  { lat: 57.25232, lon: -5.50495 },
  { lat: 57.25361, lon: -5.50816 },
  { lat: 57.25432, lon: -5.50848 },
  { lat: 57.25502, lon: -5.50817 },
  { lat: 57.25545, lon: -5.50927 },
  { lat: 57.25678, lon: -5.50971 },
  { lat: 57.25726, lon: -5.51154 },
  { lat: 57.25831, lon: -5.51231 },
  { lat: 57.25929, lon: -5.51225 },
  { lat: 57.26044, lon: -5.51443 },
  { lat: 57.26142, lon: -5.51476 },
  { lat: 57.26296, lon: -5.51673 },
  { lat: 57.2642, lon: -5.51683 },
  { lat: 57.26666, lon: -5.5208 },
  { lat: 57.2674, lon: -5.52048 },
  { lat: 57.26798, lon: -5.52092 },
  { lat: 57.26834, lon: -5.52239 },
  { lat: 57.26904, lon: -5.52242 },
  { lat: 57.26955, lon: -5.5237 },
  { lat: 57.26871, lon: -5.52622 },
  { lat: 57.26899, lon: -5.52814 },
  { lat: 57.26975, lon: -5.52955 },
  { lat: 57.27132, lon: -5.52959 },
  { lat: 57.27144, lon: -5.5301 },
  { lat: 57.27042, lon: -5.53354 },
  { lat: 57.26872, lon: -5.53529 },
  { lat: 57.26872, lon: -5.53358 },
  { lat: 57.26806, lon: -5.53494 },
  { lat: 57.26869, lon: -5.53756 },
  { lat: 57.26899, lon: -5.53722 },
  { lat: 57.2693, lon: -5.5424 },
  { lat: 57.26863, lon: -5.54416 },
  { lat: 57.2673, lon: -5.54529 },
  { lat: 57.26684, lon: -5.54715 },
  { lat: 57.26517, lon: -5.54924 },
  { lat: 57.26429, lon: -5.55223 },
  { lat: 57.26417, lon: -5.55481 },
  { lat: 57.26169, lon: -5.562 },
  { lat: 57.26111, lon: -5.56806 },
  { lat: 57.25979, lon: -5.57282 },
  { lat: 57.25778, lon: -5.57686 },
  { lat: 57.25681, lon: -5.58071 },
  { lat: 57.25697, lon: -5.58397 },
  { lat: 57.25665, lon: -5.5846 },
  { lat: 57.25621, lon: -5.5839 },
  { lat: 57.25628, lon: -5.58511 },
  { lat: 57.25691, lon: -5.58565 },
  { lat: 57.25593, lon: -5.59125 },
  { lat: 57.25697, lon: -5.59283 },
  { lat: 57.25898, lon: -5.594 },
  { lat: 57.25913, lon: -5.59741 },
  { lat: 57.25848, lon: -5.59983 },
  { lat: 57.25543, lon: -5.6037 },
  { lat: 57.25368, lon: -5.60829 },
  { lat: 57.25072, lon: -5.62416 },
  { lat: 57.2505, lon: -5.63547 },
  { lat: 57.24974, lon: -5.63721 },
  { lat: 57.24846, lon: -5.63868 },
  { lat: 57.24694, lon: -5.63937 },
  { lat: 57.24149, lon: -5.64894 },
  { lat: 57.23875, lon: -5.65172 },
  { lat: 57.23818, lon: -5.65299 },
  { lat: 57.23749, lon: -5.65308 },
  { lat: 57.23703, lon: -5.6539 },
  { lat: 57.23507, lon: -5.65517 },
  { lat: 57.23465, lon: -5.6547 },
  { lat: 57.23401, lon: -5.6555 },
  { lat: 57.23248, lon: -5.65617 },
  { lat: 57.23122, lon: -5.65561 },
  { lat: 57.23023, lon: -5.65613 },
  { lat: 57.22916, lon: -5.65526 },
  { lat: 57.22927, lon: -5.65595 },
  { lat: 57.22906, lon: -5.65542 },
  { lat: 57.22788, lon: -5.65644 },
  { lat: 57.22646, lon: -5.65433 },
  { lat: 57.22648, lon: -5.65231 },
  { lat: 57.22522, lon: -5.6497 },
  { lat: 57.22526, lon: -5.64837 },
  { lat: 57.22602, lon: -5.64729 },
  { lat: 57.22588, lon: -5.64099 },
  { lat: 57.22325, lon: -5.63329 },
  { lat: 57.22156, lon: -5.63139 },
  { lat: 57.22114, lon: -5.63253 },
  { lat: 57.22024, lon: -5.63256 },
  { lat: 57.21637, lon: -5.62624 },
  { lat: 57.21616, lon: -5.62506 },
  { lat: 57.21501, lon: -5.62475 },
  { lat: 57.21261, lon: -5.62565 },
  { lat: 57.21386, lon: -5.62417 },
  { lat: 57.21254, lon: -5.62376 },
  { lat: 57.21189, lon: -5.62458 },
  { lat: 57.21154, lon: -5.62691 },
  { lat: 57.2121, lon: -5.62575 },
  { lat: 57.21239, lon: -5.62643 },
  { lat: 57.21119, lon: -5.62863 },
  { lat: 57.21137, lon: -5.62929 },
  { lat: 57.20944, lon: -5.62943 },
  { lat: 57.20697, lon: -5.63538 },
  { lat: 57.20526, lon: -5.63528 },
  { lat: 57.2038, lon: -5.63611 },
  { lat: 57.20217, lon: -5.63765 },
  { lat: 57.20233, lon: -5.63942 },
  { lat: 57.20135, lon: -5.63955 },
  { lat: 57.20056, lon: -5.63864 },
  { lat: 57.19991, lon: -5.63865 },
  { lat: 57.19858, lon: -5.64155 },
  { lat: 57.19838, lon: -5.64118 },
  { lat: 57.19797, lon: -5.64144 },
  { lat: 57.19813, lon: -5.64225 },
  { lat: 57.19801, lon: -5.64178 },
  { lat: 57.19709, lon: -5.64262 },
  { lat: 57.19558, lon: -5.65062 },
  { lat: 57.19282, lon: -5.65587 },
  { lat: 57.18992, lon: -5.65967 },
  { lat: 57.18985, lon: -5.66297 },
  { lat: 57.18923, lon: -5.66271 },
  { lat: 57.18851, lon: -5.66319 },
  { lat: 57.18799, lon: -5.66567 },
  { lat: 57.18642, lon: -5.66762 },
  { lat: 57.18609, lon: -5.67013 },
  { lat: 57.18441, lon: -5.67439 },
  { lat: 57.18442, lon: -5.67588 },
  { lat: 57.18158, lon: -5.68004 },
  { lat: 57.18132, lon: -5.67974 },
  { lat: 57.1804, lon: -5.68049 },
  { lat: 57.18001, lon: -5.68013 },
];

export const PLOCKTON_ISLANDS: ReadonlyArray<ReadonlyArray<LatLon>> = [
  [
    { lat: 57.18002, lon: -5.73301 },
    { lat: 57.18032, lon: -5.73114 },
    { lat: 57.18097, lon: -5.73072 },
    { lat: 57.18117, lon: -5.72696 },
    { lat: 57.18308, lon: -5.72191 },
    { lat: 57.18382, lon: -5.71725 },
    { lat: 57.18487, lon: -5.71615 },
    { lat: 57.18537, lon: -5.71642 },
    { lat: 57.18636, lon: -5.71225 },
    { lat: 57.1881, lon: -5.70884 },
    { lat: 57.18886, lon: -5.70913 },
    { lat: 57.18888, lon: -5.70819 },
    { lat: 57.19006, lon: -5.70686 },
    { lat: 57.18996, lon: -5.70591 },
    { lat: 57.19047, lon: -5.70595 },
    { lat: 57.19049, lon: -5.705 },
    { lat: 57.191, lon: -5.70504 },
    { lat: 57.19109, lon: -5.70229 },
    { lat: 57.192, lon: -5.70129 },
    { lat: 57.19284, lon: -5.69793 },
    { lat: 57.19443, lon: -5.69618 },
    { lat: 57.19522, lon: -5.69426 },
    { lat: 57.19667, lon: -5.69457 },
    { lat: 57.19789, lon: -5.69335 },
    { lat: 57.19878, lon: -5.68838 },
    { lat: 57.20162, lon: -5.6827 },
    { lat: 57.20342, lon: -5.68046 },
    { lat: 57.20633, lon: -5.67296 },
    { lat: 57.20798, lon: -5.67214 },
    { lat: 57.20909, lon: -5.66907 },
    { lat: 57.21111, lon: -5.66904 },
    { lat: 57.21285, lon: -5.66805 },
    { lat: 57.21601, lon: -5.66933 },
    { lat: 57.21902, lon: -5.66741 },
    { lat: 57.21969, lon: -5.66569 },
    { lat: 57.22067, lon: -5.66632 },
    { lat: 57.22107, lon: -5.66396 },
    { lat: 57.2221, lon: -5.6643 },
    { lat: 57.22385, lon: -5.66347 },
    { lat: 57.22384, lon: -5.66404 },
    { lat: 57.2243, lon: -5.66319 },
    { lat: 57.22522, lon: -5.66266 },
    { lat: 57.22542, lon: -5.66331 },
    { lat: 57.22594, lon: -5.66251 },
    { lat: 57.22622, lon: -5.66346 },
    { lat: 57.22704, lon: -5.66371 },
    { lat: 57.22769, lon: -5.66502 },
    { lat: 57.22917, lon: -5.66495 },
    { lat: 57.23021, lon: -5.66626 },
    { lat: 57.23074, lon: -5.66598 },
    { lat: 57.23178, lon: -5.66741 },
    { lat: 57.23279, lon: -5.66774 },
    { lat: 57.23406, lon: -5.66711 },
    { lat: 57.23543, lon: -5.66724 },
    { lat: 57.23845, lon: -5.66549 },
    { lat: 57.24021, lon: -5.66278 },
    { lat: 57.24405, lon: -5.65944 },
    { lat: 57.24668, lon: -5.65383 },
    { lat: 57.24711, lon: -5.65402 },
    { lat: 57.24893, lon: -5.65249 },
    { lat: 57.25028, lon: -5.64997 },
    { lat: 57.25201, lon: -5.64877 },
    { lat: 57.25238, lon: -5.64925 },
    { lat: 57.25267, lon: -5.64886 },
    { lat: 57.25346, lon: -5.64906 },
    { lat: 57.25425, lon: -5.64831 },
    { lat: 57.25473, lon: -5.64861 },
    { lat: 57.25511, lon: -5.64758 },
    { lat: 57.25664, lon: -5.64869 },
    { lat: 57.25663, lon: -5.64934 },
    { lat: 57.25702, lon: -5.64928 },
    { lat: 57.25664, lon: -5.64994 },
    { lat: 57.25737, lon: -5.65007 },
    { lat: 57.25743, lon: -5.65263 },
    { lat: 57.25904, lon: -5.65644 },
    { lat: 57.26166, lon: -5.65867 },
    { lat: 57.262, lon: -5.65978 },
    { lat: 57.26437, lon: -5.66217 },
    { lat: 57.26492, lon: -5.66851 },
    { lat: 57.26439, lon: -5.66988 },
    { lat: 57.26489, lon: -5.6708 },
    { lat: 57.26385, lon: -5.67511 },
    { lat: 57.26443, lon: -5.68139 },
    { lat: 57.26409, lon: -5.68458 },
    { lat: 57.26311, lon: -5.68644 },
    { lat: 57.26285, lon: -5.68846 },
    { lat: 57.26349, lon: -5.69178 },
    { lat: 57.26316, lon: -5.69224 },
    { lat: 57.26323, lon: -5.69967 },
    { lat: 57.26271, lon: -5.7021 },
    { lat: 57.26314, lon: -5.7042 },
    { lat: 57.2622, lon: -5.70881 },
    { lat: 57.2626, lon: -5.71328 },
    { lat: 57.26237, lon: -5.71351 },
    { lat: 57.262, lon: -5.71285 },
    { lat: 57.26213, lon: -5.71401 },
    { lat: 57.26106, lon: -5.71889 },
    { lat: 57.26132, lon: -5.72234 },
    { lat: 57.26055, lon: -5.72804 },
    { lat: 57.26077, lon: -5.73188 },
    { lat: 57.2612, lon: -5.73351 },
    { lat: 57.26165, lon: -5.73369 },
    { lat: 57.26261, lon: -5.73126 },
    { lat: 57.26392, lon: -5.72946 },
    { lat: 57.26478, lon: -5.72758 },
    { lat: 57.26516, lon: -5.72358 },
    { lat: 57.2668, lon: -5.71748 },
    { lat: 57.2702, lon: -5.71135 },
    { lat: 57.27124, lon: -5.71101 },
    { lat: 57.27162, lon: -5.71223 },
    { lat: 57.27024, lon: -5.71401 },
    { lat: 57.26952, lon: -5.71397 },
    { lat: 57.26906, lon: -5.7163 },
    { lat: 57.27011, lon: -5.71502 },
    { lat: 57.27075, lon: -5.71665 },
    { lat: 57.27251, lon: -5.71725 },
    { lat: 57.27305, lon: -5.71875 },
    { lat: 57.27297, lon: -5.72066 },
    { lat: 57.27268, lon: -5.72167 },
    { lat: 57.2722, lon: -5.72107 },
    { lat: 57.27174, lon: -5.72208 },
    { lat: 57.27168, lon: -5.72307 },
    { lat: 57.27233, lon: -5.72325 },
    { lat: 57.27251, lon: -5.72408 },
    { lat: 57.27238, lon: -5.7263 },
    { lat: 57.27179, lon: -5.72754 },
    { lat: 57.27146, lon: -5.73327 },
    { lat: 57.26927, lon: -5.74071 },
    { lat: 57.27063, lon: -5.74221 },
    { lat: 57.27262, lon: -5.74113 },
    { lat: 57.27244, lon: -5.74017 },
    { lat: 57.27125, lon: -5.74043 },
    { lat: 57.27064, lon: -5.74115 },
    { lat: 57.27027, lon: -5.7399 },
    { lat: 57.27108, lon: -5.73542 },
    { lat: 57.272, lon: -5.73328 },
    { lat: 57.27195, lon: -5.72808 },
    { lat: 57.27248, lon: -5.72777 },
    { lat: 57.27258, lon: -5.72806 },
    { lat: 57.27395, lon: -5.72368 },
    { lat: 57.27391, lon: -5.72708 },
    { lat: 57.27296, lon: -5.72948 },
    { lat: 57.2736, lon: -5.73535 },
    { lat: 57.27461, lon: -5.73841 },
    { lat: 57.27483, lon: -5.74317 },
    { lat: 57.27313, lon: -5.7521 },
    { lat: 57.2736, lon: -5.75239 },
    { lat: 57.2736, lon: -5.75313 },
    { lat: 57.27494, lon: -5.75316 },
    { lat: 57.27494, lon: -5.75418 },
    { lat: 57.27475, lon: -5.75347 },
    { lat: 57.27372, lon: -5.75344 },
    { lat: 57.27395, lon: -5.75493 },
    { lat: 57.27339, lon: -5.7545 },
    { lat: 57.27279, lon: -5.75567 },
    { lat: 57.27145, lon: -5.76038 },
    { lat: 57.27124, lon: -5.76313 },
    { lat: 57.27206, lon: -5.76682 },
    { lat: 57.2716, lon: -5.77011 },
    { lat: 57.27196, lon: -5.77121 },
    { lat: 57.27059, lon: -5.77587 },
    { lat: 57.27103, lon: -5.77672 },
    { lat: 57.26767, lon: -5.78281 },
    { lat: 57.26794, lon: -5.78556 },
    { lat: 57.2672, lon: -5.78599 },
    { lat: 57.26732, lon: -5.78695 },
    { lat: 57.26566, lon: -5.78976 },
    { lat: 57.26589, lon: -5.79242 },
    { lat: 57.26559, lon: -5.79288 },
    { lat: 57.26525, lon: -5.79114 },
    { lat: 57.26433, lon: -5.79185 },
    { lat: 57.26393, lon: -5.79137 },
    { lat: 57.26351, lon: -5.79191 },
    { lat: 57.2632, lon: -5.79385 },
    { lat: 57.26341, lon: -5.7946 },
    { lat: 57.26401, lon: -5.79466 },
    { lat: 57.26223, lon: -5.79726 },
    { lat: 57.26253, lon: -5.79812 },
    { lat: 57.26157, lon: -5.79958 },
    { lat: 57.26103, lon: -5.80164 },
    { lat: 57.26127, lon: -5.80231 },
    { lat: 57.26035, lon: -5.80345 },
    { lat: 57.26015, lon: -5.80315 },
    { lat: 57.25979, lon: -5.80345 },
    { lat: 57.25846, lon: -5.80609 },
    { lat: 57.25814, lon: -5.80821 },
    { lat: 57.25711, lon: -5.80877 },
    { lat: 57.25622, lon: -5.81082 },
    { lat: 57.25654, lon: -5.81266 },
    { lat: 57.25623, lon: -5.81411 },
    { lat: 57.25747, lon: -5.81683 },
    { lat: 57.25754, lon: -5.81984 },
    { lat: 57.25784, lon: -5.8197 },
    { lat: 57.25734, lon: -5.82124 },
    { lat: 57.25569, lon: -5.81976 },
    { lat: 57.25602, lon: -5.82096 },
    { lat: 57.25691, lon: -5.82154 },
    { lat: 57.25715, lon: -5.82314 },
    { lat: 57.25564, lon: -5.82592 },
    { lat: 57.25625, lon: -5.8237 },
    { lat: 57.25599, lon: -5.82348 },
    { lat: 57.2553, lon: -5.82452 },
    { lat: 57.25442, lon: -5.82692 },
    { lat: 57.25422, lon: -5.82942 },
    { lat: 57.25327, lon: -5.83111 },
    { lat: 57.25326, lon: -5.83284 },
    { lat: 57.25122, lon: -5.83561 },
    { lat: 57.24867, lon: -5.84399 },
    { lat: 57.24908, lon: -5.84463 },
    { lat: 57.24735, lon: -5.84785 },
    { lat: 57.24479, lon: -5.8553 },
    { lat: 57.24402, lon: -5.85599 },
    { lat: 57.24437, lon: -5.85742 },
    { lat: 57.24286, lon: -5.86079 },
    { lat: 57.24332, lon: -5.86103 },
    { lat: 57.24164, lon: -5.86367 },
    { lat: 57.24198, lon: -5.86295 },
    { lat: 57.24393, lon: -5.86169 },
    { lat: 57.24573, lon: -5.85808 },
    { lat: 57.24678, lon: -5.85871 },
    { lat: 57.24618, lon: -5.85776 },
    { lat: 57.24618, lon: -5.85637 },
    { lat: 57.24769, lon: -5.85045 },
    { lat: 57.24877, lon: -5.84819 },
    { lat: 57.24961, lon: -5.84783 },
    { lat: 57.24955, lon: -5.8487 },
    { lat: 57.24997, lon: -5.84827 },
    { lat: 57.25025, lon: -5.84884 },
    { lat: 57.24978, lon: -5.85011 },
    { lat: 57.25004, lon: -5.85147 },
    { lat: 57.25042, lon: -5.85018 },
    { lat: 57.25117, lon: -5.85082 },
    { lat: 57.25087, lon: -5.84867 },
    { lat: 57.25154, lon: -5.84828 },
    { lat: 57.25128, lon: -5.84788 },
    { lat: 57.25066, lon: -5.84804 },
    { lat: 57.25052, lon: -5.84729 },
    { lat: 57.2514, lon: -5.84536 },
    { lat: 57.25276, lon: -5.84464 },
    { lat: 57.25265, lon: -5.84667 },
    { lat: 57.25352, lon: -5.84647 },
    { lat: 57.25322, lon: -5.84741 },
    { lat: 57.25357, lon: -5.84807 },
    { lat: 57.25418, lon: -5.84797 },
    { lat: 57.25518, lon: -5.84671 },
    { lat: 57.25373, lon: -5.85082 },
    { lat: 57.25409, lon: -5.85174 },
    { lat: 57.25376, lon: -5.85144 },
    { lat: 57.24976, lon: -5.85629 },
    { lat: 57.24883, lon: -5.85589 },
    { lat: 57.24933, lon: -5.85718 },
    { lat: 57.24903, lon: -5.85816 },
    { lat: 57.24945, lon: -5.86172 },
    { lat: 57.24862, lon: -5.86206 },
    { lat: 57.24752, lon: -5.86431 },
    { lat: 57.2465, lon: -5.86777 },
    { lat: 57.24662, lon: -5.86827 },
    { lat: 57.24738, lon: -5.86824 },
    { lat: 57.24655, lon: -5.87103 },
    { lat: 57.24467, lon: -5.87365 },
    { lat: 57.24426, lon: -5.87326 },
    { lat: 57.24367, lon: -5.87361 },
    { lat: 57.24298, lon: -5.87584 },
    { lat: 57.24112, lon: -5.87579 },
    { lat: 57.23911, lon: -5.87877 },
    { lat: 57.23848, lon: -5.88127 },
    { lat: 57.23896, lon: -5.88333 },
    { lat: 57.23799, lon: -5.88566 },
    { lat: 57.23851, lon: -5.89147 },
    { lat: 57.23973, lon: -5.89543 },
    { lat: 57.23972, lon: -5.89768 },
    { lat: 57.2393, lon: -5.89848 },
    { lat: 57.23987, lon: -5.89871 },
    { lat: 57.24145, lon: -5.90156 },
    { lat: 57.24161, lon: -5.90409 },
    { lat: 57.24214, lon: -5.90466 },
    { lat: 57.24153, lon: -5.90416 },
    { lat: 57.24134, lon: -5.9046 },
    { lat: 57.2419, lon: -5.90658 },
    { lat: 57.24181, lon: -5.91062 },
    { lat: 57.2424, lon: -5.91212 },
    { lat: 57.24135, lon: -5.91425 },
    { lat: 57.24258, lon: -5.91254 },
    { lat: 57.24238, lon: -5.91076 },
    { lat: 57.24328, lon: -5.91047 },
    { lat: 57.24404, lon: -5.90954 },
    { lat: 57.2459, lon: -5.90921 },
    { lat: 57.2472, lon: -5.90788 },
    { lat: 57.24885, lon: -5.90799 },
    { lat: 57.25068, lon: -5.90738 },
    { lat: 57.25291, lon: -5.9047 },
    { lat: 57.25407, lon: -5.90628 },
    { lat: 57.25576, lon: -5.91135 },
    { lat: 57.25723, lon: -5.9132 },
    { lat: 57.25821, lon: -5.91577 },
    { lat: 57.26011, lon: -5.91689 },
    { lat: 57.26209, lon: -5.92163 },
    { lat: 57.26277, lon: -5.92205 },
    { lat: 57.26417, lon: -5.92775 },
    { lat: 57.26404, lon: -5.92948 },
    { lat: 57.26284, lon: -5.93238 },
    { lat: 57.26377, lon: -5.93634 },
    { lat: 57.263, lon: -5.93673 },
    { lat: 57.26205, lon: -5.93588 },
    { lat: 57.26141, lon: -5.93592 },
    { lat: 57.26152, lon: -5.93545 },
    { lat: 57.26039, lon: -5.93541 },
    { lat: 57.25961, lon: -5.93673 },
    { lat: 57.25891, lon: -5.93665 },
    { lat: 57.25938, lon: -5.93965 },
    { lat: 57.26089, lon: -5.94429 },
    { lat: 57.26258, lon: -5.94649 },
    { lat: 57.26303, lon: -5.94932 },
  ],
  [
    { lat: 57.54994, lon: -5.52234 },
    { lat: 57.54921, lon: -5.51699 },
    { lat: 57.54915, lon: -5.51756 },
    { lat: 57.54796, lon: -5.51846 },
    { lat: 57.54824, lon: -5.51968 },
    { lat: 57.54785, lon: -5.52206 },
    { lat: 57.54699, lon: -5.52096 },
    { lat: 57.54659, lon: -5.523 },
    { lat: 57.54611, lon: -5.52272 },
    { lat: 57.54574, lon: -5.52354 },
    { lat: 57.54551, lon: -5.52292 },
    { lat: 57.54621, lon: -5.52193 },
    { lat: 57.54684, lon: -5.51898 },
    { lat: 57.54654, lon: -5.51635 },
    { lat: 57.54505, lon: -5.51491 },
    { lat: 57.54195, lon: -5.51445 },
    { lat: 57.54091, lon: -5.51363 },
    { lat: 57.54057, lon: -5.51369 },
    { lat: 57.54024, lon: -5.51647 },
    { lat: 57.53865, lon: -5.51933 },
    { lat: 57.5378, lon: -5.51992 },
    { lat: 57.53636, lon: -5.51954 },
    { lat: 57.5358, lon: -5.51882 },
    { lat: 57.53406, lon: -5.5188 },
    { lat: 57.53151, lon: -5.52001 },
    { lat: 57.53035, lon: -5.52208 },
    { lat: 57.53002, lon: -5.52369 },
    { lat: 57.53168, lon: -5.52839 },
    { lat: 57.53074, lon: -5.53188 },
    { lat: 57.53009, lon: -5.53121 },
    { lat: 57.53064, lon: -5.53212 },
    { lat: 57.52941, lon: -5.53323 },
    { lat: 57.52936, lon: -5.53468 },
    { lat: 57.52961, lon: -5.53543 },
    { lat: 57.53034, lon: -5.53545 },
    { lat: 57.53025, lon: -5.53731 },
    { lat: 57.53072, lon: -5.53746 },
    { lat: 57.53106, lon: -5.53671 },
    { lat: 57.53128, lon: -5.53726 },
    { lat: 57.53089, lon: -5.54131 },
    { lat: 57.53175, lon: -5.54376 },
    { lat: 57.53215, lon: -5.54409 },
    { lat: 57.53266, lon: -5.54341 },
    { lat: 57.53284, lon: -5.54443 },
    { lat: 57.53347, lon: -5.54457 },
    { lat: 57.53376, lon: -5.54368 },
    { lat: 57.53423, lon: -5.54357 },
    { lat: 57.53385, lon: -5.54468 },
    { lat: 57.5342, lon: -5.54719 },
    { lat: 57.53504, lon: -5.54752 },
    { lat: 57.53575, lon: -5.5504 },
    { lat: 57.53449, lon: -5.55235 },
    { lat: 57.53441, lon: -5.5536 },
    { lat: 57.53505, lon: -5.55432 },
    { lat: 57.53487, lon: -5.55655 },
    { lat: 57.53535, lon: -5.55637 },
    { lat: 57.53583, lon: -5.55729 },
    { lat: 57.53579, lon: -5.55598 },
    { lat: 57.53644, lon: -5.55578 },
    { lat: 57.53705, lon: -5.55699 },
    { lat: 57.53734, lon: -5.55668 },
    { lat: 57.53763, lon: -5.55706 },
    { lat: 57.53658, lon: -5.56091 },
    { lat: 57.53707, lon: -5.56139 },
    { lat: 57.53796, lon: -5.56125 },
    { lat: 57.53833, lon: -5.56216 },
    { lat: 57.53743, lon: -5.56186 },
    { lat: 57.53752, lon: -5.56275 },
    { lat: 57.53708, lon: -5.56248 },
    { lat: 57.53704, lon: -5.5631 },
    { lat: 57.53674, lon: -5.56297 },
    { lat: 57.53659, lon: -5.5617 },
    { lat: 57.53538, lon: -5.56033 },
    { lat: 57.53422, lon: -5.56026 },
    { lat: 57.5337, lon: -5.55905 },
    { lat: 57.53295, lon: -5.55901 },
    { lat: 57.53101, lon: -5.56475 },
    { lat: 57.53141, lon: -5.56602 },
    { lat: 57.53153, lon: -5.56437 },
    { lat: 57.53223, lon: -5.56335 },
    { lat: 57.53308, lon: -5.5652 },
    { lat: 57.533, lon: -5.56615 },
    { lat: 57.53385, lon: -5.56599 },
    { lat: 57.5343, lon: -5.56717 },
    { lat: 57.53371, lon: -5.56862 },
    { lat: 57.53423, lon: -5.57095 },
    { lat: 57.535, lon: -5.56953 },
    { lat: 57.53537, lon: -5.56946 },
    { lat: 57.53542, lon: -5.57007 },
    { lat: 57.53596, lon: -5.56974 },
    { lat: 57.53677, lon: -5.57219 },
    { lat: 57.53614, lon: -5.57696 },
    { lat: 57.53509, lon: -5.57741 },
    { lat: 57.53455, lon: -5.57734 },
    { lat: 57.53337, lon: -5.57552 },
    { lat: 57.53312, lon: -5.57622 },
    { lat: 57.5323, lon: -5.57434 },
    { lat: 57.53069, lon: -5.57356 },
    { lat: 57.52964, lon: -5.57167 },
    { lat: 57.52898, lon: -5.57294 },
    { lat: 57.52922, lon: -5.57452 },
    { lat: 57.53102, lon: -5.57742 },
    { lat: 57.53451, lon: -5.58041 },
    { lat: 57.5324, lon: -5.58107 },
    { lat: 57.53241, lon: -5.58211 },
    { lat: 57.53287, lon: -5.58218 },
    { lat: 57.53371, lon: -5.58381 },
    { lat: 57.53419, lon: -5.58673 },
    { lat: 57.5337, lon: -5.5879 },
    { lat: 57.53211, lon: -5.58777 },
    { lat: 57.53151, lon: -5.58864 },
    { lat: 57.53066, lon: -5.59648 },
    { lat: 57.52932, lon: -5.59795 },
    { lat: 57.53093, lon: -5.59739 },
    { lat: 57.53195, lon: -5.59951 },
    { lat: 57.53449, lon: -5.60129 },
    { lat: 57.5355, lon: -5.6032 },
    { lat: 57.53591, lon: -5.60576 },
    { lat: 57.53523, lon: -5.60831 },
    { lat: 57.53436, lon: -5.60841 },
    { lat: 57.53404, lon: -5.60899 },
    { lat: 57.53449, lon: -5.61013 },
    { lat: 57.53426, lon: -5.61082 },
    { lat: 57.53236, lon: -5.61152 },
    { lat: 57.53059, lon: -5.61449 },
    { lat: 57.52835, lon: -5.61569 },
    { lat: 57.52827, lon: -5.61694 },
    { lat: 57.5289, lon: -5.61747 },
    { lat: 57.52894, lon: -5.61949 },
    { lat: 57.52979, lon: -5.62232 },
    { lat: 57.53, lon: -5.62259 },
    { lat: 57.53181, lon: -5.62168 },
    { lat: 57.53215, lon: -5.62189 },
    { lat: 57.53105, lon: -5.62568 },
    { lat: 57.53029, lon: -5.62604 },
    { lat: 57.53064, lon: -5.62377 },
    { lat: 57.52954, lon: -5.623 },
    { lat: 57.52909, lon: -5.62317 },
    { lat: 57.52883, lon: -5.62197 },
    { lat: 57.5277, lon: -5.6207 },
    { lat: 57.52612, lon: -5.62006 },
    { lat: 57.52527, lon: -5.61856 },
    { lat: 57.52317, lon: -5.61839 },
    { lat: 57.52214, lon: -5.61876 },
    { lat: 57.52085, lon: -5.62102 },
    { lat: 57.52188, lon: -5.62427 },
    { lat: 57.52255, lon: -5.63308 },
    { lat: 57.52338, lon: -5.63306 },
    { lat: 57.52383, lon: -5.6321 },
    { lat: 57.52406, lon: -5.63261 },
    { lat: 57.52517, lon: -5.63258 },
    { lat: 57.5263, lon: -5.63402 },
    { lat: 57.52686, lon: -5.63373 },
    { lat: 57.52684, lon: -5.63219 },
    { lat: 57.52811, lon: -5.63141 },
    { lat: 57.52896, lon: -5.62941 },
    { lat: 57.52955, lon: -5.63017 },
    { lat: 57.52972, lon: -5.63186 },
    { lat: 57.53033, lon: -5.63244 },
    { lat: 57.53271, lon: -5.62949 },
    { lat: 57.53305, lon: -5.63148 },
    { lat: 57.53445, lon: -5.63318 },
    { lat: 57.53544, lon: -5.63575 },
    { lat: 57.53625, lon: -5.63674 },
    { lat: 57.53648, lon: -5.63641 },
    { lat: 57.53687, lon: -5.63943 },
    { lat: 57.53647, lon: -5.6431 },
    { lat: 57.53567, lon: -5.64452 },
    { lat: 57.53582, lon: -5.64602 },
    { lat: 57.53672, lon: -5.64682 },
    { lat: 57.5381, lon: -5.64401 },
    { lat: 57.53895, lon: -5.64573 },
    { lat: 57.53956, lon: -5.64496 },
    { lat: 57.5401, lon: -5.64537 },
    { lat: 57.54044, lon: -5.6467 },
    { lat: 57.54166, lon: -5.64563 },
    { lat: 57.54186, lon: -5.64598 },
    { lat: 57.54249, lon: -5.64792 },
    { lat: 57.54236, lon: -5.65007 },
    { lat: 57.54183, lon: -5.65054 },
    { lat: 57.54244, lon: -5.654 },
    { lat: 57.54197, lon: -5.6556 },
    { lat: 57.54226, lon: -5.65689 },
    { lat: 57.54056, lon: -5.6597 },
    { lat: 57.53994, lon: -5.65917 },
    { lat: 57.54002, lon: -5.658 },
    { lat: 57.53972, lon: -5.65773 },
    { lat: 57.53958, lon: -5.65811 },
    { lat: 57.53934, lon: -5.65666 },
    { lat: 57.53726, lon: -5.6568 },
    { lat: 57.53686, lon: -5.65605 },
    { lat: 57.53705, lon: -5.65498 },
    { lat: 57.53604, lon: -5.6542 },
    { lat: 57.53563, lon: -5.65459 },
    { lat: 57.53551, lon: -5.65381 },
    { lat: 57.53475, lon: -5.65396 },
    { lat: 57.53446, lon: -5.65262 },
    { lat: 57.53269, lon: -5.653 },
    { lat: 57.53176, lon: -5.65191 },
    { lat: 57.53005, lon: -5.65328 },
    { lat: 57.5292, lon: -5.65285 },
    { lat: 57.528, lon: -5.65377 },
    { lat: 57.52717, lon: -5.6511 },
    { lat: 57.52618, lon: -5.64972 },
    { lat: 57.525, lon: -5.64965 },
    { lat: 57.52177, lon: -5.65206 },
    { lat: 57.52043, lon: -5.65214 },
    { lat: 57.51955, lon: -5.65095 },
    { lat: 57.51956, lon: -5.64957 },
    { lat: 57.51706, lon: -5.64829 },
    { lat: 57.51414, lon: -5.6455 },
    { lat: 57.51308, lon: -5.64514 },
    { lat: 57.51125, lon: -5.64586 },
    { lat: 57.5108, lon: -5.6451 },
    { lat: 57.51142, lon: -5.64785 },
    { lat: 57.51074, lon: -5.64778 },
    { lat: 57.51031, lon: -5.64893 },
    { lat: 57.50944, lon: -5.64875 },
    { lat: 57.50899, lon: -5.64943 },
    { lat: 57.51089, lon: -5.65141 },
    { lat: 57.51265, lon: -5.6522 },
    { lat: 57.51339, lon: -5.65378 },
    { lat: 57.51489, lon: -5.65492 },
    { lat: 57.51623, lon: -5.6585 },
    { lat: 57.515, lon: -5.66166 },
    { lat: 57.51571, lon: -5.66253 },
    { lat: 57.51586, lon: -5.66436 },
    { lat: 57.51707, lon: -5.66309 },
    { lat: 57.51701, lon: -5.66352 },
    { lat: 57.51834, lon: -5.66419 },
    { lat: 57.51935, lon: -5.66412 },
    { lat: 57.52022, lon: -5.66503 },
    { lat: 57.52068, lon: -5.66734 },
    { lat: 57.52266, lon: -5.66902 },
    { lat: 57.52297, lon: -5.67167 },
    { lat: 57.52402, lon: -5.67293 },
    { lat: 57.52483, lon: -5.67319 },
    { lat: 57.52497, lon: -5.67236 },
    { lat: 57.52683, lon: -5.67347 },
    { lat: 57.52729, lon: -5.67863 },
    { lat: 57.52622, lon: -5.67913 },
    { lat: 57.52605, lon: -5.68085 },
    { lat: 57.52763, lon: -5.6825 },
    { lat: 57.52639, lon: -5.68458 },
    { lat: 57.5263, lon: -5.68574 },
    { lat: 57.52679, lon: -5.68702 },
    { lat: 57.52872, lon: -5.68896 },
    { lat: 57.53042, lon: -5.69218 },
    { lat: 57.53055, lon: -5.6969 },
    { lat: 57.53144, lon: -5.699 },
    { lat: 57.53376, lon: -5.70048 },
    { lat: 57.53473, lon: -5.69986 },
    { lat: 57.53525, lon: -5.70005 },
    { lat: 57.5354, lon: -5.6994 },
    { lat: 57.53609, lon: -5.7001 },
    { lat: 57.53796, lon: -5.69963 },
    { lat: 57.5396, lon: -5.70086 },
    { lat: 57.54043, lon: -5.70026 },
    { lat: 57.54114, lon: -5.70044 },
    { lat: 57.54122, lon: -5.69956 },
    { lat: 57.54453, lon: -5.70482 },
    { lat: 57.54465, lon: -5.70365 },
    { lat: 57.54258, lon: -5.69958 },
    { lat: 57.54284, lon: -5.69854 },
    { lat: 57.5442, lon: -5.69823 },
    { lat: 57.54487, lon: -5.69915 },
    { lat: 57.54606, lon: -5.69897 },
    { lat: 57.54674, lon: -5.69815 },
    { lat: 57.54755, lon: -5.69893 },
    { lat: 57.54994, lon: -5.69954 },
  ],
  [
    { lat: 57.35103, lon: -5.83849 },
    { lat: 57.35092, lon: -5.8394 },
    { lat: 57.35184, lon: -5.84115 },
    { lat: 57.35044, lon: -5.8431 },
    { lat: 57.34905, lon: -5.84206 },
    { lat: 57.3486, lon: -5.84265 },
    { lat: 57.3465, lon: -5.84257 },
    { lat: 57.34568, lon: -5.84168 },
    { lat: 57.34434, lon: -5.84183 },
    { lat: 57.34369, lon: -5.84095 },
    { lat: 57.34191, lon: -5.84144 },
    { lat: 57.34066, lon: -5.84084 },
    { lat: 57.34019, lon: -5.83989 },
    { lat: 57.33829, lon: -5.83965 },
    { lat: 57.33789, lon: -5.84015 },
    { lat: 57.33602, lon: -5.84007 },
    { lat: 57.33523, lon: -5.83895 },
    { lat: 57.3349, lon: -5.83923 },
    { lat: 57.33471, lon: -5.83802 },
    { lat: 57.33408, lon: -5.83829 },
    { lat: 57.33372, lon: -5.83697 },
    { lat: 57.33322, lon: -5.83704 },
    { lat: 57.33277, lon: -5.83438 },
    { lat: 57.33324, lon: -5.83145 },
    { lat: 57.334, lon: -5.8307 },
    { lat: 57.3335, lon: -5.82989 },
    { lat: 57.33359, lon: -5.82798 },
    { lat: 57.33306, lon: -5.82786 },
    { lat: 57.33297, lon: -5.8273 },
    { lat: 57.3343, lon: -5.82624 },
    { lat: 57.33463, lon: -5.82266 },
    { lat: 57.33592, lon: -5.81982 },
    { lat: 57.33611, lon: -5.8202 },
    { lat: 57.33662, lon: -5.8196 },
    { lat: 57.3373, lon: -5.82005 },
    { lat: 57.33828, lon: -5.81898 },
    { lat: 57.33949, lon: -5.81949 },
    { lat: 57.34005, lon: -5.82053 },
    { lat: 57.34249, lon: -5.82122 },
    { lat: 57.3432, lon: -5.82208 },
    { lat: 57.34476, lon: -5.82529 },
    { lat: 57.34496, lon: -5.82881 },
    { lat: 57.34546, lon: -5.82925 },
    { lat: 57.34612, lon: -5.82905 },
    { lat: 57.3466, lon: -5.8297 },
    { lat: 57.34742, lon: -5.82953 },
    { lat: 57.34928, lon: -5.83225 },
    { lat: 57.3493, lon: -5.83291 },
    { lat: 57.35037, lon: -5.83374 },
    { lat: 57.35103, lon: -5.83849 },
  ],
  [
    { lat: 57.5499, lon: -5.71276 },
    { lat: 57.54934, lon: -5.71305 },
    { lat: 57.54912, lon: -5.71188 },
    { lat: 57.54692, lon: -5.7093 },
    { lat: 57.54637, lon: -5.70991 },
    { lat: 57.54639, lon: -5.71347 },
    { lat: 57.54463, lon: -5.71166 },
    { lat: 57.54209, lon: -5.70714 },
    { lat: 57.54127, lon: -5.70738 },
    { lat: 57.53987, lon: -5.70657 },
    { lat: 57.53968, lon: -5.70725 },
    { lat: 57.5401, lon: -5.70898 },
    { lat: 57.54163, lon: -5.71008 },
    { lat: 57.54189, lon: -5.71132 },
    { lat: 57.54251, lon: -5.71112 },
    { lat: 57.54349, lon: -5.71246 },
    { lat: 57.54351, lon: -5.71206 },
    { lat: 57.54377, lon: -5.71225 },
    { lat: 57.54402, lon: -5.71315 },
    { lat: 57.54365, lon: -5.71373 },
    { lat: 57.54428, lon: -5.71464 },
    { lat: 57.54388, lon: -5.71686 },
    { lat: 57.54428, lon: -5.71902 },
    { lat: 57.54495, lon: -5.72083 },
    { lat: 57.54606, lon: -5.71983 },
    { lat: 57.54682, lon: -5.7207 },
    { lat: 57.54633, lon: -5.72317 },
    { lat: 57.54736, lon: -5.7259 },
    { lat: 57.54715, lon: -5.72657 },
    { lat: 57.54769, lon: -5.72706 },
    { lat: 57.54696, lon: -5.72893 },
    { lat: 57.5467, lon: -5.73439 },
    { lat: 57.54517, lon: -5.73587 },
    { lat: 57.54433, lon: -5.73845 },
    { lat: 57.54439, lon: -5.74026 },
    { lat: 57.54341, lon: -5.74161 },
    { lat: 57.54558, lon: -5.74545 },
    { lat: 57.54781, lon: -5.74779 },
    { lat: 57.54966, lon: -5.74888 },
  ],
  [
    { lat: 57.27465, lon: -5.94958 },
    { lat: 57.27484, lon: -5.94446 },
    { lat: 57.277, lon: -5.93917 },
    { lat: 57.27805, lon: -5.93787 },
    { lat: 57.27845, lon: -5.93505 },
    { lat: 57.27945, lon: -5.93451 },
    { lat: 57.2797, lon: -5.93544 },
    { lat: 57.28065, lon: -5.93582 },
    { lat: 57.28105, lon: -5.93422 },
    { lat: 57.28187, lon: -5.9341 },
    { lat: 57.28236, lon: -5.93323 },
    { lat: 57.28217, lon: -5.9318 },
    { lat: 57.28121, lon: -5.93086 },
    { lat: 57.28097, lon: -5.929 },
    { lat: 57.28169, lon: -5.92867 },
    { lat: 57.28185, lon: -5.92971 },
    { lat: 57.28263, lon: -5.93063 },
    { lat: 57.28348, lon: -5.93062 },
    { lat: 57.28348, lon: -5.92802 },
    { lat: 57.28286, lon: -5.92616 },
    { lat: 57.28409, lon: -5.92582 },
    { lat: 57.28426, lon: -5.92534 },
    { lat: 57.28454, lon: -5.92635 },
    { lat: 57.28501, lon: -5.92594 },
    { lat: 57.28593, lon: -5.92665 },
    { lat: 57.28764, lon: -5.92678 },
    { lat: 57.2887, lon: -5.92759 },
    { lat: 57.29035, lon: -5.92772 },
    { lat: 57.29215, lon: -5.92574 },
    { lat: 57.29377, lon: -5.92222 },
    { lat: 57.29528, lon: -5.92199 },
    { lat: 57.29582, lon: -5.921 },
    { lat: 57.29697, lon: -5.92027 },
    { lat: 57.29817, lon: -5.92059 },
    { lat: 57.29905, lon: -5.91997 },
    { lat: 57.29937, lon: -5.9202 },
  ],
  [
    { lat: 57.18025, lon: -5.86769 },
    { lat: 57.18242, lon: -5.86194 },
    { lat: 57.1824, lon: -5.86015 },
    { lat: 57.18179, lon: -5.85968 },
    { lat: 57.18114, lon: -5.86036 },
    { lat: 57.18078, lon: -5.85827 },
    { lat: 57.18247, lon: -5.85481 },
    { lat: 57.18337, lon: -5.85455 },
    { lat: 57.18347, lon: -5.85273 },
    { lat: 57.18493, lon: -5.85204 },
    { lat: 57.18533, lon: -5.84987 },
    { lat: 57.18486, lon: -5.85013 },
    { lat: 57.18481, lon: -5.84981 },
    { lat: 57.1862, lon: -5.84905 },
    { lat: 57.18639, lon: -5.84678 },
    { lat: 57.18743, lon: -5.84535 },
    { lat: 57.188, lon: -5.8454 },
    { lat: 57.18796, lon: -5.84361 },
    { lat: 57.18848, lon: -5.84417 },
    { lat: 57.18891, lon: -5.84361 },
    { lat: 57.18929, lon: -5.83867 },
    { lat: 57.19001, lon: -5.83815 },
    { lat: 57.18944, lon: -5.8379 },
    { lat: 57.1892, lon: -5.8383 },
    { lat: 57.18889, lon: -5.83762 },
    { lat: 57.18712, lon: -5.84036 },
    { lat: 57.18548, lon: -5.84137 },
    { lat: 57.18459, lon: -5.84124 },
    { lat: 57.18453, lon: -5.84251 },
    { lat: 57.18322, lon: -5.8433 },
    { lat: 57.18206, lon: -5.84576 },
    { lat: 57.18209, lon: -5.84743 },
    { lat: 57.18063, lon: -5.8524 },
    { lat: 57.18107, lon: -5.85208 },
    { lat: 57.1801, lon: -5.85422 },
  ],
  [
    { lat: 57.33612, lon: -5.84133 },
    { lat: 57.33786, lon: -5.84143 },
    { lat: 57.34036, lon: -5.84238 },
    { lat: 57.34111, lon: -5.84214 },
    { lat: 57.34257, lon: -5.84359 },
    { lat: 57.34402, lon: -5.84405 },
    { lat: 57.34488, lon: -5.84354 },
    { lat: 57.34797, lon: -5.84396 },
    { lat: 57.34996, lon: -5.84687 },
    { lat: 57.34978, lon: -5.84796 },
    { lat: 57.35031, lon: -5.84916 },
    { lat: 57.34883, lon: -5.85035 },
    { lat: 57.34752, lon: -5.8531 },
    { lat: 57.34741, lon: -5.85218 },
    { lat: 57.34623, lon: -5.85081 },
    { lat: 57.34416, lon: -5.85057 },
    { lat: 57.34354, lon: -5.84939 },
    { lat: 57.34223, lon: -5.8487 },
    { lat: 57.34167, lon: -5.84872 },
    { lat: 57.34157, lon: -5.84927 },
    { lat: 57.34125, lon: -5.84874 },
    { lat: 57.34069, lon: -5.84931 },
    { lat: 57.3407, lon: -5.84819 },
    { lat: 57.33994, lon: -5.84702 },
    { lat: 57.33869, lon: -5.84713 },
    { lat: 57.33743, lon: -5.84504 },
    { lat: 57.33659, lon: -5.84476 },
    { lat: 57.33647, lon: -5.84509 },
    { lat: 57.33638, lon: -5.84438 },
    { lat: 57.33557, lon: -5.84427 },
    { lat: 57.33585, lon: -5.84333 },
    { lat: 57.3354, lon: -5.8414 },
    { lat: 57.33612, lon: -5.84133 },
  ],
  [
    { lat: 57.2685, lon: -5.86449 },
    { lat: 57.2691, lon: -5.86456 },
    { lat: 57.26948, lon: -5.86221 },
    { lat: 57.26888, lon: -5.85699 },
    { lat: 57.27147, lon: -5.85311 },
    { lat: 57.27158, lon: -5.84932 },
    { lat: 57.27238, lon: -5.84927 },
    { lat: 57.27428, lon: -5.84757 },
    { lat: 57.27476, lon: -5.84768 },
    { lat: 57.2754, lon: -5.84899 },
    { lat: 57.27583, lon: -5.8487 },
    { lat: 57.27604, lon: -5.84966 },
    { lat: 57.27824, lon: -5.85208 },
    { lat: 57.28029, lon: -5.85304 },
    { lat: 57.28094, lon: -5.85411 },
    { lat: 57.28152, lon: -5.85437 },
    { lat: 57.28187, lon: -5.85397 },
    { lat: 57.28239, lon: -5.85451 },
    { lat: 57.28275, lon: -5.85613 },
    { lat: 57.2823, lon: -5.85649 },
    { lat: 57.28247, lon: -5.8572 },
    { lat: 57.28144, lon: -5.85782 },
    { lat: 57.28107, lon: -5.86134 },
    { lat: 57.2789, lon: -5.86441 },
    { lat: 57.27772, lon: -5.86998 },
    { lat: 57.27751, lon: -5.86953 },
    { lat: 57.27601, lon: -5.87098 },
    { lat: 57.272, lon: -5.86873 },
    { lat: 57.27108, lon: -5.86607 },
    { lat: 57.27013, lon: -5.86527 },
    { lat: 57.26911, lon: -5.86559 },
    { lat: 57.2685, lon: -5.86449 },
  ],
  [
    { lat: 57.37572, lon: -5.65297 },
    { lat: 57.37568, lon: -5.65143 },
    { lat: 57.37514, lon: -5.65178 },
    { lat: 57.37492, lon: -5.65099 },
    { lat: 57.37402, lon: -5.65072 },
    { lat: 57.37406, lon: -5.64986 },
    { lat: 57.37335, lon: -5.65005 },
    { lat: 57.37333, lon: -5.6495 },
    { lat: 57.3742, lon: -5.64912 },
    { lat: 57.37574, lon: -5.64969 },
    { lat: 57.37562, lon: -5.64835 },
    { lat: 57.37636, lon: -5.64866 },
    { lat: 57.37656, lon: -5.64811 },
    { lat: 57.37735, lon: -5.64821 },
    { lat: 57.37794, lon: -5.64686 },
    { lat: 57.37875, lon: -5.64815 },
    { lat: 57.37829, lon: -5.64818 },
    { lat: 57.37823, lon: -5.64866 },
    { lat: 57.37776, lon: -5.64846 },
    { lat: 57.3774, lon: -5.65178 },
    { lat: 57.37631, lon: -5.65249 },
    { lat: 57.37657, lon: -5.65316 },
    { lat: 57.37579, lon: -5.65345 },
    { lat: 57.37572, lon: -5.65297 },
  ],
  [
    { lat: 57.26213, lon: -5.57869 },
    { lat: 57.26233, lon: -5.57386 },
    { lat: 57.26366, lon: -5.57286 },
    { lat: 57.26549, lon: -5.57312 },
    { lat: 57.26685, lon: -5.57241 },
    { lat: 57.26862, lon: -5.574 },
    { lat: 57.26908, lon: -5.57718 },
    { lat: 57.26784, lon: -5.58053 },
    { lat: 57.26625, lon: -5.58081 },
    { lat: 57.26503, lon: -5.57949 },
    { lat: 57.26491, lon: -5.57853 },
    { lat: 57.26604, lon: -5.57661 },
    { lat: 57.26535, lon: -5.57583 },
    { lat: 57.26415, lon: -5.57718 },
    { lat: 57.2643, lon: -5.57838 },
    { lat: 57.2633, lon: -5.57895 },
    { lat: 57.26303, lon: -5.57766 },
    { lat: 57.26376, lon: -5.57613 },
    { lat: 57.26366, lon: -5.57344 },
    { lat: 57.26254, lon: -5.57453 },
    { lat: 57.26213, lon: -5.57869 },
  ],
  [
    { lat: 57.41504, lon: -5.44219 },
    { lat: 57.4171, lon: -5.44294 },
    { lat: 57.41697, lon: -5.44203 },
    { lat: 57.41799, lon: -5.44207 },
    { lat: 57.41866, lon: -5.4428 },
    { lat: 57.41772, lon: -5.44342 },
    { lat: 57.41746, lon: -5.4474 },
    { lat: 57.41684, lon: -5.44789 },
    { lat: 57.41626, lon: -5.44753 },
    { lat: 57.41611, lon: -5.44476 },
    { lat: 57.41546, lon: -5.44548 },
    { lat: 57.41493, lon: -5.44471 },
    { lat: 57.41485, lon: -5.44386 },
    { lat: 57.41598, lon: -5.44329 },
    { lat: 57.41547, lon: -5.44368 },
    { lat: 57.41548, lon: -5.44322 },
    { lat: 57.41485, lon: -5.44329 },
    { lat: 57.41504, lon: -5.44219 },
  ],
  [
    { lat: 57.35118, lon: -5.85179 },
    { lat: 57.35243, lon: -5.85086 },
    { lat: 57.35289, lon: -5.8511 },
    { lat: 57.354, lon: -5.85063 },
    { lat: 57.35393, lon: -5.85188 },
    { lat: 57.35427, lon: -5.85183 },
    { lat: 57.35456, lon: -5.85278 },
    { lat: 57.35522, lon: -5.85272 },
    { lat: 57.35523, lon: -5.85323 },
    { lat: 57.35645, lon: -5.85376 },
    { lat: 57.35677, lon: -5.85443 },
    { lat: 57.35377, lon: -5.8586 },
    { lat: 57.35296, lon: -5.85839 },
    { lat: 57.35236, lon: -5.85608 },
    { lat: 57.35141, lon: -5.85502 },
    { lat: 57.35094, lon: -5.85305 },
    { lat: 57.35118, lon: -5.85179 },
  ],
  [
    { lat: 57.29937, lon: -5.9202 },
    { lat: 57.30017, lon: -5.91986 },
    { lat: 57.30081, lon: -5.92049 },
    { lat: 57.30305, lon: -5.92105 },
    { lat: 57.30466, lon: -5.92327 },
    { lat: 57.30714, lon: -5.92468 },
    { lat: 57.30818, lon: -5.92606 },
    { lat: 57.30905, lon: -5.92847 },
    { lat: 57.31057, lon: -5.93033 },
    { lat: 57.31117, lon: -5.9342 },
    { lat: 57.31171, lon: -5.93471 },
    { lat: 57.31264, lon: -5.93792 },
    { lat: 57.31363, lon: -5.93806 },
    { lat: 57.31436, lon: -5.93945 },
    { lat: 57.31672, lon: -5.94709 },
    { lat: 57.31824, lon: -5.94839 },
    { lat: 57.31844, lon: -5.94996 },
  ],
  [
    { lat: 57.3056, lon: -5.89118 },
    { lat: 57.30803, lon: -5.88449 },
    { lat: 57.30877, lon: -5.88357 },
    { lat: 57.30975, lon: -5.88336 },
    { lat: 57.31134, lon: -5.88524 },
    { lat: 57.31162, lon: -5.88695 },
    { lat: 57.31361, lon: -5.89022 },
    { lat: 57.31382, lon: -5.89239 },
    { lat: 57.31564, lon: -5.89358 },
    { lat: 57.31484, lon: -5.89628 },
    { lat: 57.31414, lon: -5.89664 },
    { lat: 57.31281, lon: -5.89598 },
    { lat: 57.31225, lon: -5.89651 },
    { lat: 57.30984, lon: -5.8951 },
    { lat: 57.30731, lon: -5.89489 },
    { lat: 57.30598, lon: -5.89318 },
    { lat: 57.3056, lon: -5.89118 },
  ],
  [
    { lat: 57.28018, lon: -5.74038 },
    { lat: 57.27834, lon: -5.74236 },
    { lat: 57.27778, lon: -5.74094 },
    { lat: 57.27783, lon: -5.73979 },
    { lat: 57.27858, lon: -5.73977 },
    { lat: 57.27901, lon: -5.73818 },
    { lat: 57.2799, lon: -5.73781 },
    { lat: 57.27937, lon: -5.73638 },
    { lat: 57.2787, lon: -5.73692 },
    { lat: 57.27856, lon: -5.73653 },
    { lat: 57.27853, lon: -5.73547 },
    { lat: 57.27889, lon: -5.73561 },
    { lat: 57.27933, lon: -5.73486 },
    { lat: 57.28021, lon: -5.73587 },
    { lat: 57.2807, lon: -5.73543 },
    { lat: 57.28018, lon: -5.74038 },
  ],
  [
    { lat: 57.54975, lon: -5.66666 },
    { lat: 57.5482, lon: -5.66703 },
    { lat: 57.5477, lon: -5.66778 },
    { lat: 57.547, lon: -5.66751 },
    { lat: 57.54621, lon: -5.66978 },
    { lat: 57.54607, lon: -5.66852 },
    { lat: 57.54558, lon: -5.66874 },
    { lat: 57.54544, lon: -5.66824 },
    { lat: 57.54575, lon: -5.6674 },
    { lat: 57.54642, lon: -5.66727 },
    { lat: 57.54622, lon: -5.66522 },
    { lat: 57.54715, lon: -5.66356 },
    { lat: 57.54718, lon: -5.66137 },
    { lat: 57.54878, lon: -5.65764 },
    { lat: 57.54992, lon: -5.65649 },
  ],
  [
    { lat: 57.28979, lon: -5.73853 },
    { lat: 57.28951, lon: -5.73977 },
    { lat: 57.28862, lon: -5.73908 },
    { lat: 57.28812, lon: -5.73999 },
    { lat: 57.28752, lon: -5.73971 },
    { lat: 57.28741, lon: -5.73833 },
    { lat: 57.28708, lon: -5.73891 },
    { lat: 57.2864, lon: -5.73864 },
    { lat: 57.28563, lon: -5.73903 },
    { lat: 57.28631, lon: -5.73662 },
    { lat: 57.28713, lon: -5.73645 },
    { lat: 57.28751, lon: -5.73724 },
    { lat: 57.28817, lon: -5.73579 },
    { lat: 57.28979, lon: -5.73853 },
  ],
  [
    { lat: 57.41756, lon: -5.44503 },
    { lat: 57.41782, lon: -5.44359 },
    { lat: 57.41885, lon: -5.44312 },
    { lat: 57.41917, lon: -5.44452 },
    { lat: 57.4203, lon: -5.44617 },
    { lat: 57.41993, lon: -5.4486 },
    { lat: 57.41921, lon: -5.44888 },
    { lat: 57.41946, lon: -5.44757 },
    { lat: 57.41919, lon: -5.44783 },
    { lat: 57.41887, lon: -5.44693 },
    { lat: 57.41801, lon: -5.4469 },
    { lat: 57.41806, lon: -5.44422 },
    { lat: 57.41751, lon: -5.44666 },
    { lat: 57.41756, lon: -5.44503 },
  ],
  [
    { lat: 57.42021, lon: -5.45846 },
    { lat: 57.41968, lon: -5.45924 },
    { lat: 57.41864, lon: -5.45641 },
    { lat: 57.41833, lon: -5.45373 },
    { lat: 57.41902, lon: -5.45263 },
    { lat: 57.41873, lon: -5.45376 },
    { lat: 57.41893, lon: -5.45571 },
    { lat: 57.41952, lon: -5.45671 },
    { lat: 57.4193, lon: -5.45761 },
    { lat: 57.41974, lon: -5.45748 },
    { lat: 57.41968, lon: -5.45828 },
    { lat: 57.42021, lon: -5.45846 },
  ],
  [
    { lat: 57.37594, lon: -5.83547 },
    { lat: 57.37551, lon: -5.8369 },
    { lat: 57.37482, lon: -5.83685 },
    { lat: 57.37271, lon: -5.83953 },
    { lat: 57.37243, lon: -5.83804 },
    { lat: 57.37281, lon: -5.83477 },
    { lat: 57.37387, lon: -5.83476 },
    { lat: 57.37439, lon: -5.83412 },
    { lat: 57.3746, lon: -5.83452 },
    { lat: 57.37549, lon: -5.83441 },
    { lat: 57.37594, lon: -5.83547 },
  ],
  [
    { lat: 57.52509, lon: -5.65692 },
    { lat: 57.52657, lon: -5.65757 },
    { lat: 57.52752, lon: -5.66214 },
    { lat: 57.52657, lon: -5.66202 },
    { lat: 57.52514, lon: -5.66099 },
    { lat: 57.52452, lon: -5.65926 },
    { lat: 57.52354, lon: -5.65817 },
    { lat: 57.5234, lon: -5.65734 },
    { lat: 57.5239, lon: -5.65665 },
    { lat: 57.52509, lon: -5.65692 },
  ],
  [
    { lat: 57.5454, lon: -5.65556 },
    { lat: 57.54453, lon: -5.6573 },
    { lat: 57.54356, lon: -5.65722 },
    { lat: 57.54318, lon: -5.65799 },
    { lat: 57.5426, lon: -5.6576 },
    { lat: 57.54244, lon: -5.6567 },
    { lat: 57.5435, lon: -5.65532 },
    { lat: 57.54404, lon: -5.6555 },
    { lat: 57.54463, lon: -5.6548 },
    { lat: 57.5454, lon: -5.65556 },
  ],
  [
    { lat: 57.24023, lon: -5.88399 },
    { lat: 57.24114, lon: -5.88372 },
    { lat: 57.24156, lon: -5.88195 },
    { lat: 57.24216, lon: -5.88393 },
    { lat: 57.24284, lon: -5.88463 },
    { lat: 57.24293, lon: -5.88608 },
    { lat: 57.24137, lon: -5.88496 },
    { lat: 57.23984, lon: -5.88628 },
    { lat: 57.23958, lon: -5.88514 },
    { lat: 57.24023, lon: -5.88399 },
  ],
  [
    { lat: 57.31581, lon: -5.89655 },
    { lat: 57.31659, lon: -5.89612 },
    { lat: 57.31632, lon: -5.89745 },
    { lat: 57.31683, lon: -5.89749 },
    { lat: 57.31575, lon: -5.89864 },
    { lat: 57.31577, lon: -5.89776 },
    { lat: 57.31626, lon: -5.89734 },
    { lat: 57.31556, lon: -5.89736 },
    { lat: 57.31581, lon: -5.89655 },
  ],
  [
    { lat: 57.3705, lon: -5.64709 },
    { lat: 57.37041, lon: -5.64656 },
    { lat: 57.36983, lon: -5.64712 },
    { lat: 57.36961, lon: -5.64684 },
    { lat: 57.37048, lon: -5.6452 },
    { lat: 57.37172, lon: -5.64704 },
    { lat: 57.37086, lon: -5.64863 },
    { lat: 57.37042, lon: -5.64816 },
    { lat: 57.3705, lon: -5.64709 },
  ],
  [
    { lat: 57.27492, lon: -5.52324 },
    { lat: 57.27451, lon: -5.52479 },
    { lat: 57.2759, lon: -5.52575 },
    { lat: 57.27644, lon: -5.52509 },
    { lat: 57.27664, lon: -5.52764 },
    { lat: 57.27591, lon: -5.52877 },
    { lat: 57.27379, lon: -5.52506 },
    { lat: 57.27462, lon: -5.52282 },
    { lat: 57.27492, lon: -5.52324 },
  ],
  [
    { lat: 57.27589, lon: -5.91927 },
    { lat: 57.27644, lon: -5.92078 },
    { lat: 57.27536, lon: -5.92135 },
    { lat: 57.27363, lon: -5.9199 },
    { lat: 57.27347, lon: -5.91836 },
    { lat: 57.27409, lon: -5.91892 },
    { lat: 57.27431, lon: -5.91846 },
    { lat: 57.27511, lon: -5.91932 },
    { lat: 57.27589, lon: -5.91927 },
  ],
  [
    { lat: 57.3397, lon: -5.61691 },
    { lat: 57.34028, lon: -5.61657 },
    { lat: 57.34032, lon: -5.61805 },
    { lat: 57.34011, lon: -5.6187 },
    { lat: 57.33939, lon: -5.61886 },
    { lat: 57.33964, lon: -5.61809 },
    { lat: 57.33922, lon: -5.61742 },
    { lat: 57.3397, lon: -5.61691 },
  ],
  [
    { lat: 57.32695, lon: -5.9264 },
    { lat: 57.32657, lon: -5.92711 },
    { lat: 57.3258, lon: -5.92753 },
    { lat: 57.32549, lon: -5.92724 },
    { lat: 57.32582, lon: -5.92532 },
    { lat: 57.32653, lon: -5.92582 },
    { lat: 57.32709, lon: -5.92547 },
    { lat: 57.32695, lon: -5.9264 },
  ],
];

/** Combined coastline for AreaData.coastline. Index 0 is the mainland;
 *  the rest are closed island polygons. */
export const PLOCKTON_COASTLINE: ReadonlyArray<ReadonlyArray<LatLon>> = [
  PLOCKTON_MAINLAND,
  ...PLOCKTON_ISLANDS,
];
